import LastSavedStatus from "./LastSavedStatus";
import HtmlImageEditor from './HtmlImageEditor';
import HtmlTextEditor from './HtmlTextEditor';
import HtmlCodeEditor from './HtmlCodeEditor';
import HtmlCtaEditor from './HtmlCtaEditor';
import {
    BlockTypeSelect,
    BoldItalicUnderlineToggles,
    CreateLink,
    diffSourcePlugin,
    DiffSourceToggleWrapper,
    headingsPlugin,
    linkDialogPlugin,
    listsPlugin,
    ListsToggle,
    MDXEditor,
    quotePlugin,
    Separator,
    tablePlugin,
    thematicBreakPlugin,
    toolbarPlugin,
    UndoRedo
} from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';
import _ from 'lodash';
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ColorPicker from 'react-best-gradient-color-picker';
import { ReactSortable } from "react-sortablejs";
import api from '../../api';
import { ReactComponent as AlignBottom } from "../../assets/images/icons/ic-align-bottom.svg";
import { ReactComponent as AlignCenterHorizontal } from "../../assets/images/icons/ic-align-center-horizontal.svg";
import { ReactComponent as AlignCenterVertical } from "../../assets/images/icons/ic-align-center-vertical.svg";
import { ReactComponent as AlignLeft } from "../../assets/images/icons/ic-align-left.svg";
import { ReactComponent as AlignRight } from "../../assets/images/icons/ic-align-right.svg";
import { ReactComponent as AlignTop } from "../../assets/images/icons/ic-align-top.svg";
import { ReactComponent as ResetIcon } from "../../assets/images/icons/ic-arrow-reset.svg";
import { ReactComponent as BorderAll } from "../../assets/images/icons/ic-border-all.svg";
import { ReactComponent as BorderBottom } from "../../assets/images/icons/ic-border-bottom.svg";
import { ReactComponent as BorderLeft } from "../../assets/images/icons/ic-border-left.svg";
import { ReactComponent as BorderRight } from "../../assets/images/icons/ic-border-right.svg";
import { ReactComponent as BorderTop } from "../../assets/images/icons/ic-border-top.svg";
import { ReactComponent as StyleIcon } from "../../assets/images/icons/ic-brush.svg";
import { ReactComponent as ChevronIcon } from "../../assets/images/icons/ic-chevron.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/icons/ic-close.svg";
import { ReactComponent as CopyIcon } from "../../assets/images/icons/ic-copy.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/ic-delete.svg";
import { ReactComponent as StructIcon } from "../../assets/images/icons/ic-folder-closed.svg";
import { ReactComponent as InfoIcon } from "../../assets/images/icons/ic-info.svg";
import { ReactComponent as ApplyAllIcon } from "../../assets/images/icons/ic-layers.svg";
import { ReactComponent as TextAlignCenter } from "../../assets/images/icons/ic-text-align-center.svg";
import { ReactComponent as TextAlignJustify } from "../../assets/images/icons/ic-text-align-justify.svg";
import { ReactComponent as TextAlignLeft } from "../../assets/images/icons/ic-text-align-left.svg";
import { ReactComponent as TextAlignRight } from "../../assets/images/icons/ic-text-align-right.svg";
import { ReactComponent as TextCapitalize } from "../../assets/images/icons/ic-text-capitalize.svg";
import { ReactComponent as TextItalic } from "../../assets/images/icons/ic-text-italic.svg";
import { ReactComponent as TextLinethrough } from "../../assets/images/icons/ic-text-line-through.svg";
import { ReactComponent as TextLowercase } from "../../assets/images/icons/ic-text-lowercase.svg";
import { ReactComponent as TextOverline } from "../../assets/images/icons/ic-text-overline.svg";
import { ReactComponent as TargetIcon } from "../../assets/images/icons/ic-target.svg";
import { ReactComponent as TextUnderline } from "../../assets/images/icons/ic-text-underline.svg";
import { ReactComponent as TextUppercase } from "../../assets/images/icons/ic-text-uppercase.svg";
import { ReactComponent as SpaceBetween } from "../../assets/images/icons/ic-space-between.svg";
import { ReactComponent as SpaceAround } from "../../assets/images/icons/ic-space-around.svg";
import { BlockType, ButtonStatus, FileType } from "../../common/constants";
import { Each } from '../../common/Each';
import typo from "../../typography.module.css";
import Button from "../Button";
import Checkbox from '../Checkbox';
import Collapsable from '../Collapsable';
import Dialog from '../dialogs/Dialog';
import IconsDialog from '../dialogs/IconsDialog';
import MultipleSelect from '../MultipleSelect';
import Select from "../Select";
import TextInput from "../TextInput";
import TooltipWrapper from "../TooltipWrapper";
import Uploader from "../Uploader";
import { actionsOptions, backgroundPositionOptions, backgroundRepeatOptions, backgroundSizeOptions, borderOptions, buttonAppearanceOptions, buttonTypeOptions, carouselTypeOptions, cssProperties, cursorOptions, fetchPriorityOptions, fieldTypeOptions, flexDirectionOptions, fontOptions, fontWeightOptions, iconPositionOptions, imageLoadingOptions, overflowOptions, positionOptions, rowWrapOptions, themeColors, visibilityOptions, whiteSpaceOptions } from './PageBuilderConstants';
import { usePageBuilder } from './PageBuilderContext';
import PageBuilderStructure from "./PageBuilderStructure";
import styles from "./PageBuilderToolbar.module.css";
import UnitSelector from './UnitSelector';

const MdxInlineColorButton = ({ onOpen }) => {
    const openInlineColorDialog = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();

        if (typeof onOpen !== 'function') {
            return;
        }
        onOpen();
    }, [onOpen]);

    return (
        <button
            type="button"
            title="Colore testo selezionato"
            onMouseDown={(event) => {
                event.preventDefault();
            }}
            onClick={openInlineColorDialog}
            style={{
                border: '1px solid rgba(0, 0, 0, 0.2)',
                borderRadius: '6px',
                background: '#fff',
                padding: '0.2rem 0.45rem',
                fontWeight: 700,
                cursor: 'pointer'
            }}
        >
            A
        </button>
    );
}

const PageBuilderToolbar = ({
    grid,
    view,
    isPreviewMode = false,
    customTab,
    saveDisabled,
    onToolbarToggle = () => { },
    activeVersion = 'published',
    onPublish = () => { },
    onSaveDraft = () => { },
    onExportToDraft = () => { },
    isSaving = false,
    lastSavedAt = null,
    publishButtonStatus = null,
    saveDraftButtonStatus = null,
    hideExportToDraft = false,
    onGridUpdate = () => { },
    forcedTab = null,
    onForcedTabApplied = () => { },
    onEyedropStateChange = () => { },
}) => {

    const { page, selectedBlock, selectedBlocks, selectedBlockIds, findBlockById, updateBlock, selectBlock } = usePageBuilder();
    const [courses, setCourses] = useState([])
    // const [block, setBlock] = useState(structuredClone(selectedBlock))
    const [selectedTab, setSelectedTab] = useState(customTab ? 'custom' : 'struct')
    const [openToolbar, setOpenToolbar] = useState(true)
    const [colorBackground, setColorBackground] = useState(false)
    const [imageBackground, setImageBackground] = useState(false)
    const [iconsDialogOpen, setIconsDialogOpen] = useState(false)
    // const [data, setData] = useState(block?.data ?? null)
    const [selectedLists, setSelectedLists] = useState([]);
    const [lists, setLists] = useState([]);
    const [mdxColorDialogOpen, setMdxColorDialogOpen] = useState(false);
    const [mdxInlineColor, setMdxInlineColor] = useState('var(--primary)');
    const [mdxInlineFontSize, setMdxInlineFontSize] = useState('');
    const [mdxInlineFontWeight, setMdxInlineFontWeight] = useState('');
    const [mdxEditorRefreshNonce, setMdxEditorRefreshNonce] = useState(0);
    const loadedAcListsRef = useRef('');
    const eyeDropperPatchedRef = useRef(false);
    const isMountedRef = useRef(true);
    const mdxSelectedTextRef = useRef('');
    const mdxColorTargetRef = useRef(null);
    const [eyeDropActive, setEyeDropActive] = useState(false)
    const [boxShadow, setBoxShadow] = useState({
        hOffset: '',
        vOffset: '',
        blur: '',
        spread: '',
        color: '',
        inset: ''
    });
    const [transform, setTransform] = useState({
        translateX: '',
        translateY: '',
        rotate: '',
        scale: ''
    });
    const [expandedActionIndex, setExpandedActionIndex] = useState(null);
    const [actionTargetPickerIndex, setActionTargetPickerIndex] = useState(null);
    const [actionTargetCandidateId, setActionTargetCandidateId] = useState(null);
    const [actionTargetSourceBlockId, setActionTargetSourceBlockId] = useState(null);

    const mdxInlineFontWeightOptions = useMemo(() => {
        return [
            { id: -1, name: 'Default', value: '' },
            ...fontWeightOptions
        ];
    }, []);

    const aspectRatioPresetOptions = useMemo(() => {
        return [
            { id: 1, name: '1:1', value: '1 / 1' },
            { id: 2, name: '16:9', value: '16 / 9' },
            { id: 3, name: '9:16', value: '9 / 16' },
            { id: 4, name: '21:9', value: '21 / 9' },
            { id: 5, name: '9:21', value: '9 / 21' },
            { id: 6, name: '4:3', value: '4 / 3' },
            { id: 7, name: '3:4', value: '3 / 4' },
            { id: 8, name: '2:3', value: '2 / 3' },
            { id: 9, name: '3:2', value: '3 / 2' },
            { id: -1, name: 'CUSTOM', value: '__custom__' },
        ];
    }, []);

    const [customAspectRatioWidth, setCustomAspectRatioWidth] = useState('');
    const [customAspectRatioHeight, setCustomAspectRatioHeight] = useState('');

    const expandBorderRadiusShorthand = (value) => {
        if (typeof value !== 'string') {
            return [];
        }

        const parts = value.trim().split(/\s+/).filter(Boolean);
        if (!parts.length) {
            return [];
        }

        if (parts.length === 1) {
            return [parts[0], parts[0], parts[0], parts[0]];
        }

        if (parts.length === 2) {
            return [parts[0], parts[1], parts[0], parts[1]];
        }

        if (parts.length === 3) {
            return [parts[0], parts[1], parts[2], parts[1]];
        }

        return [parts[0], parts[1], parts[2], parts[3]];
    }

    const parseBoxShadow = (boxShadow) => {
        if (typeof boxShadow !== 'string' || boxShadow.trim() === '') {
            return {
                hOffset: '',
                vOffset: '',
                blur: '',
                spread: '',
                color: '',
                inset: ''
            };
        }

        const tokens = [];
        let buffer = '';
        let depth = 0;

        for (const char of boxShadow.trim()) {
            if (char === '(') {
                depth += 1;
            } else if (char === ')' && depth > 0) {
                depth -= 1;
            }

            if (char === ' ' && depth === 0) {
                if (buffer.trim()) {
                    tokens.push(buffer.trim());
                }
                buffer = '';
            } else {
                buffer += char;
            }
        }
        if (buffer.trim()) {
            tokens.push(buffer.trim());
        }

        let inset = '';
        const insetIndex = tokens.findIndex((token) => token.toLowerCase() === 'inset');
        if (insetIndex >= 0) {
            inset = tokens.splice(insetIndex, 1)[0];
        }

        const isLengthToken = (token) => {
            if (typeof token !== 'string' || token.trim() === '') {
                return false;
            }
            return /^-?\d*\.?\d+(px|rem|em|%|vh|vw|vmin|vmax)?$/i.test(token.trim());
        };

        let color = '';
        if (tokens.length >= 3) {
            const lastToken = tokens[tokens.length - 1];
            if (!isLengthToken(lastToken)) {
                color = tokens.pop();
            }
        }

        const [hOffset = '', vOffset = '', blur = '', spread = ''] = tokens;

        return {
            hOffset,
            vOffset,
            blur,
            spread,
            color,
            inset
        };
    }

    const parseTransform = (transform) => {
        if (typeof transform !== 'string' || transform.trim() === '') {
            return {
                translateX: '',
                translateY: '',
                rotate: '',
                scale: ''
            };
        }

        const extract = (expr, fnName) => {
            const regex = new RegExp(`${fnName}\\(([^)]+)\\)`, 'i');
            const match = expr.match(regex);
            return match ? match[1].trim() : '';
        };

        return {
            translateX: extract(transform, 'translateX'),
            translateY: extract(transform, 'translateY'),
            rotate: extract(transform, 'rotate'),
            scale: extract(transform, 'scale')
        };
    }

    const parseBorder = (border) => {
        if (typeof border !== 'string' || border.trim() === '') {
            return {
                width: null,
                style: null,
                color: null
            };
        }

        const borderStyles = ['none', 'solid', 'dashed', 'dotted', 'double', 'groove', 'ridge', 'inset', 'outset'];
        let width = null;
        let style = null;
        let color = null;
        let remaining = border.trim().replace(/;$/, '');

        const colorPatterns = [
            /rgba?\([^)]*\)/i,
            /#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})\b/i
        ];

        for (const pattern of colorPatterns) {
            const match = remaining.match(pattern);
            if (match && typeof match.index === 'number') {
                color = match[0].trim();
                remaining = `${remaining.slice(0, match.index)} ${remaining.slice(match.index + match[0].length)}`.trim();
                break;
            }
        }

        const tokens = remaining.split(/\s+/).filter(Boolean);

        for (const token of tokens) {
            const lower = token.toLowerCase();

            if (!width && /^(\d*\.\d+|\d+)(px|rem|em|%)?$/.test(token)) {
                width = token;
                continue;
            }

            if (!style && borderStyles.includes(lower)) {
                style = token;
                continue;
            }

            if (!color) {
                color = token;
            }
        }

        return { width, style, color };
    }

    const actionSelectionLocked = useMemo(() => {
        return actionTargetPickerIndex != null && !!actionTargetSourceBlockId;
    }, [actionTargetPickerIndex, actionTargetSourceBlockId]);

    const lockedToolbarBlock = useMemo(() => {
        if (!actionSelectionLocked) {
            return null;
        }

        return findBlockById(actionTargetSourceBlockId);
    }, [actionSelectionLocked, actionTargetSourceBlockId, findBlockById]);

    const isMultiSelection = useMemo(() => {
        if (actionSelectionLocked) {
            return false;
        }
        return Array.isArray(selectedBlockIds) && selectedBlockIds.length > 1;
    }, [actionSelectionLocked, selectedBlockIds]);

    const hasUniformSelectedType = useMemo(() => {
        if (!isMultiSelection || !Array.isArray(selectedBlocks) || selectedBlocks.length === 0) {
            return false;
        }
        const firstType = selectedBlocks[0]?.type;
        if (!firstType) {
            return false;
        }
        return selectedBlocks.every((item) => item?.type === firstType);
    }, [isMultiSelection, selectedBlocks]);

    const selectionSummaryLabel = useMemo(() => {
        if (actionSelectionLocked) {
            return null;
        }

        const count = Array.isArray(selectedBlockIds) ? selectedBlockIds.length : 0;
        if (count <= 1) {
            return null;
        }
        if (hasUniformSelectedType && selectedBlocks?.[0]?.type) {
            return `${count} blocchi (${selectedBlocks[0].type})`;
        }
        return `${count} blocchi (misti)`;
    }, [actionSelectionLocked, hasUniformSelectedType, selectedBlockIds, selectedBlocks]);

    const block = useMemo(() => {
        if (actionSelectionLocked) {
            return lockedToolbarBlock ? structuredClone(lockedToolbarBlock) : null;
        }

        if (!isMultiSelection) {
            return structuredClone(selectedBlock);
        }

        if (!Array.isArray(selectedBlocks) || selectedBlocks.length === 0) {
            return null;
        }

        if (!hasUniformSelectedType) {
            return {
                id: null,
                type: '__mixed__',
                style: {},
                styleTablet: {},
                styleMobile: {},
                data: {},
                content: []
            };
        }

        const getCommonObject = (values) => {
            if (!Array.isArray(values) || values.length === 0) {
                return {};
            }

            const normalizedValues = values.map((value) => _.isPlainObject(value) ? value : {});
            const keys = new Set(normalizedValues.flatMap((value) => Object.keys(value)));
            const common = {};

            keys.forEach((key) => {
                const firstHasKey = Object.prototype.hasOwnProperty.call(normalizedValues[0], key);
                if (!firstHasKey) {
                    return;
                }

                const firstValue = normalizedValues[0][key];
                const isShared = normalizedValues.every((value) => {
                    if (!Object.prototype.hasOwnProperty.call(value, key)) {
                        return false;
                    }
                    return _.isEqual(value[key], firstValue);
                });

                if (isShared) {
                    common[key] = firstValue;
                }
            });

            return common;
        };

        const getCommonValue = (values) => {
            if (!Array.isArray(values) || values.length === 0) {
                return null;
            }

            const firstValue = values[0];
            const allPlainObjects = values.every((value) => _.isPlainObject(value));

            if (allPlainObjects) {
                return getCommonObject(values);
            }

            const isShared = values.every((value) => _.isEqual(value, firstValue));
            if (isShared) {
                if (Array.isArray(firstValue)) {
                    return [...firstValue];
                }
                if (_.isPlainObject(firstValue)) {
                    return { ...firstValue };
                }
                return firstValue;
            }

            if (typeof firstValue === 'string') {
                return '';
            }
            if (Array.isArray(firstValue)) {
                return [];
            }
            if (_.isPlainObject(firstValue)) {
                return {};
            }

            return null;
        };

        const base = structuredClone(selectedBlocks[0]);
        return {
            ...base,
            id: null,
            style: getCommonObject(selectedBlocks.map((selected) => selected?.style)),
            styleTablet: getCommonObject(selectedBlocks.map((selected) => selected?.styleTablet)),
            styleMobile: getCommonObject(selectedBlocks.map((selected) => selected?.styleMobile)),
            data: getCommonValue(selectedBlocks.map((selected) => selected?.data))
        };
    }, [selectedBlock, selectedBlocks, isMultiSelection, hasUniformSelectedType, actionSelectionLocked, lockedToolbarBlock])

    const targetBlockIds = useMemo(() => {
        if (actionSelectionLocked && actionTargetSourceBlockId) {
            return [actionTargetSourceBlockId];
        }

        if (Array.isArray(selectedBlockIds) && selectedBlockIds.length > 0) {
            return selectedBlockIds;
        }
        if (selectedBlock?.id) {
            return [selectedBlock.id];
        }
        return [];
    }, [actionSelectionLocked, actionTargetSourceBlockId, selectedBlock?.id, selectedBlockIds]);

    const normalizeColorToken = useCallback((value) => {
        if (typeof value !== 'string') {
            return '';
        }
        return value.trim().toLowerCase().replace(/\s+/g, '');
    }, []);

    const isNeutralGrayscaleToken = useCallback((token) => {
        if (typeof token !== 'string') {
            return false;
        }

        const color = token.trim().toLowerCase();
        if (!color || color.startsWith('var(')) {
            return false;
        }

        const isClose = (a, b, tolerance = 6) => Math.abs(a - b) <= tolerance;
        const isGrayRgb = (r, g, b) => isClose(r, g) && isClose(g, b);
        const isNearWhiteRgb = (r, g, b) => {
            const minChannel = Math.min(r, g, b);
            const maxChannel = Math.max(r, g, b);
            return minChannel >= 230 && (maxChannel - minChannel) <= 32;
        };

        if (color.startsWith('#')) {
            let hex = color.slice(1);

            if (hex.length === 3 || hex.length === 4) {
                hex = hex
                    .slice(0, 3)
                    .split('')
                    .map((char) => `${char}${char}`)
                    .join('');
            } else if (hex.length === 6 || hex.length === 8) {
                hex = hex.slice(0, 6);
            } else {
                return false;
            }

            const r = parseInt(hex.slice(0, 2), 16);
            const g = parseInt(hex.slice(2, 4), 16);
            const b = parseInt(hex.slice(4, 6), 16);

            if ([r, g, b].some((channel) => Number.isNaN(channel))) {
                return false;
            }

            return isGrayRgb(r, g, b) || isNearWhiteRgb(r, g, b);
        }

        if (color.startsWith('rgb')) {
            const contentMatch = color.match(/rgba?\(([^)]+)\)/i);
            if (!contentMatch) {
                return false;
            }

            const raw = contentMatch[1]
                .replace(/\//g, ' ')
                .replace(/,/g, ' ')
                .trim()
                .split(/\s+/)
                .slice(0, 3);

            if (raw.length < 3) {
                return false;
            }

            const toChannel = (part) => {
                if (!part) {
                    return NaN;
                }
                if (part.endsWith('%')) {
                    const value = parseFloat(part.slice(0, -1));
                    if (Number.isNaN(value)) {
                        return NaN;
                    }
                    return (value / 100) * 255;
                }
                return parseFloat(part);
            };

            const [r, g, b] = raw.map((part) => toChannel(part));

            if ([r, g, b].some((channel) => Number.isNaN(channel))) {
                return false;
            }

            return isGrayRgb(r, g, b) || isNearWhiteRgb(r, g, b);
        }

        if (color.startsWith('hsl')) {
            const contentMatch = color.match(/hsla?\(([^)]+)\)/i);
            if (!contentMatch) {
                return false;
            }

            const raw = contentMatch[1]
                .replace(/\//g, ' ')
                .replace(/,/g, ' ')
                .trim()
                .split(/\s+/);

            if (raw.length < 3) {
                return false;
            }

            const saturationRaw = raw[1];
            const saturation = parseFloat(saturationRaw?.replace('%', ''));
            const lightnessRaw = raw[2];
            const lightness = parseFloat(lightnessRaw?.replace('%', ''));

            if (Number.isNaN(saturation) || Number.isNaN(lightness)) {
                return false;
            }

            const isGray = saturation <= 2;
            const isNearWhite = lightness >= 90 && saturation <= 25;

            return isGray || isNearWhite;
        }

        return false;
    }, []);

    const hasZeroAlphaToken = useCallback((token) => {
        if (typeof token !== 'string') {
            return false;
        }

        const color = token.trim().toLowerCase();
        if (!color || color.startsWith('var(')) {
            return false;
        }

        if (color.startsWith('#')) {
            const hex = color.slice(1);
            if (hex.length === 4) {
                return hex[3] === '0';
            }
            if (hex.length === 8) {
                return hex.slice(6, 8) === '00';
            }
            return false;
        }

        if (color.startsWith('rgb') || color.startsWith('hsl')) {
            const contentMatch = color.match(/^[a-z]+\(([^)]+)\)$/i);
            if (!contentMatch) {
                return false;
            }

            const content = contentMatch[1].trim();
            let alphaToken = null;

            if (content.includes('/')) {
                alphaToken = content.split('/').pop()?.trim();
            } else {
                const commaParts = content.split(',').map((part) => part.trim()).filter(Boolean);
                if (commaParts.length === 4) {
                    alphaToken = commaParts[3];
                } else {
                    const spaceParts = content.split(/\s+/).filter(Boolean);
                    if (spaceParts.length === 4) {
                        alphaToken = spaceParts[3];
                    }
                }
            }

            if (!alphaToken) {
                return false;
            }

            let alphaValue = NaN;
            if (alphaToken.endsWith('%')) {
                alphaValue = parseFloat(alphaToken.slice(0, -1)) / 100;
            } else {
                alphaValue = parseFloat(alphaToken);
            }

            if (Number.isNaN(alphaValue)) {
                return false;
            }

            return alphaValue <= 0;
        }

        return false;
    }, []);

    const themeColorNormalizedSet = useMemo(() => {
        const set = new Set();
        themeColors.forEach((color) => {
            [color?.value, color?.hex].forEach((token) => {
                const normalized = normalizeColorToken(token);
                if (normalized) {
                    set.add(normalized);
                }
            });
        });
        return set;
    }, [normalizeColorToken]);

    const pageUsedColors = useMemo(() => {
        if (!page) {
            return [];
        }

        const colorPatterns = [
            /#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})\b/gi,
            /rgba?\([^)]*\)/gi,
            /hsla?\([^)]*\)/gi,
            /var\(--[^)]+\)/gi,
        ];

        const extractedColors = [];
        const seen = new Set();

        const pushColor = (token) => {
            const color = typeof token === 'string' ? token.trim() : '';
            if (!color) {
                return;
            }
            const normalized = normalizeColorToken(color);
            if (!normalized ||
                seen.has(normalized) ||
                themeColorNormalizedSet.has(normalized) ||
                isNeutralGrayscaleToken(color) ||
                hasZeroAlphaToken(color)) {
                return;
            }
            seen.add(normalized);
            extractedColors.push(color);
        };

        const walk = (value) => {
            if (value == null) {
                return;
            }

            if (typeof value === 'string') {
                colorPatterns.forEach((pattern) => {
                    const matches = value.match(pattern);
                    if (matches) {
                        matches.forEach((match) => pushColor(match));
                    }
                });
                return;
            }

            if (Array.isArray(value)) {
                value.forEach((item) => walk(item));
                return;
            }

            if (typeof value === 'object') {
                Object.values(value).forEach((item) => walk(item));
            }
        };

        walk(page);
        return extractedColors;
    }, [page, normalizeColorToken, themeColorNormalizedSet, isNeutralGrayscaleToken, hasZeroAlphaToken]);

    const renderUsedPageColors = useCallback((onSelectColor) => {
        if (typeof onSelectColor !== 'function' || pageUsedColors.length === 0) {
            return null;
        }

        return (
            <>
                <div style={{ width: '100%', height: '1px', backgroundColor: 'rgba(21, 21, 21, 0.12)' }}></div>
                <div className={styles.themeColors}>
                    <Each of={pageUsedColors} render={(colorValue) => {
                        return (
                            <TooltipWrapper text={`${colorValue}`}>
                                <div onClick={() => {
                                    onSelectColor(colorValue)
                                }} className={styles.color} style={{ backgroundColor: `${colorValue}` }}></div>
                            </TooltipWrapper>
                        )
                    }} />
                </div>
            </>
        );
    }, [pageUsedColors]);

    const viewStyle = useMemo(() => {
        if (!block) return {}
        let s = block.style ?? {}
        switch (view) {
            case 'desktop':
                s = block?.style ?? {};
                break;
            case 'tablet':
                s = { ...block?.style, ...block?.styleTablet } ?? {};
                break;
            case 'mobile':
                s = { ...block?.style, ...block?.styleTablet, ...block?.styleMobile } ?? {};
                break;
            default:
                s = block.style ?? {};
        }

        if (typeof s?.borderRadius === 'string' && s.borderRadius.trim() !== '') {
            const shorthandBorderRadius = expandBorderRadiusShorthand(s.borderRadius)
            const normalizedBorderRadius = {
                topLeft: s?.borderTopLeftRadius ?? shorthandBorderRadius[0] ?? '',
                topRight: s?.borderTopRightRadius ?? shorthandBorderRadius[1] ?? '',
                bottomRight: s?.borderBottomRightRadius ?? shorthandBorderRadius[2] ?? '',
                bottomLeft: s?.borderBottomLeftRadius ?? shorthandBorderRadius[3] ?? ''
            };
            s["borderTopLeftRadius"] = normalizedBorderRadius.topLeft
            s["borderTopRightRadius"] = normalizedBorderRadius.topRight
            s["borderBottomRightRadius"] = normalizedBorderRadius.bottomRight
            s["borderBottomLeftRadius"] = normalizedBorderRadius.bottomLeft
            delete s["borderRadius"]
        }


        if (s.backgroundImage) {
            if (s.backgroundImage.startsWith('url')) {
                setImageBackground(true)
                s.backgroundImage = s.backgroundImage.replaceAll("url('", "").replaceAll("')", "").replaceAll("url(\"", "").replaceAll("\")", "")
            }
            if (s.backgroundImage.startsWith('linear-gradient') || s.backgroundImage.startsWith('radial-gradient')) {
                setImageBackground(false)
                setColorBackground(true)
            }
            if (s.backgroundImage.startsWith('http')) {
                s.backgroundImage = `url("${s.backgroundImage}")`
            }
        }
        else {
            setImageBackground(false)
        }

        if (s.backgroundColor && s.backgroundColor !== 'transparent' && s.backgroundColor !== 'unset') {
            setColorBackground(true)
        }

        if (s.boxShadow) {
            const parsedBoxShadow = parseBoxShadow(s.boxShadow);
            setBoxShadow(parsedBoxShadow);
        }

        if (s.transform) {
            const parsedTransform = parseTransform(s.transform);
            setTransform(parsedTransform);
        }

        if (s.borderLeft || s.borderTop || s.borderBottom || s.borderRight) {
            delete (s.border)
        }

        if (s.border) {
            const parsed = parseBorder(s.border)
            s.borderTop = `${parsed.width ?? ''} ${parsed.style ?? ''} ${parsed.color ?? ''}`;
            s.borderRight = `${parsed.width ?? ''} ${parsed.style ?? ''} ${parsed.color ?? ''}`;
            s.borderBottom = `${parsed.width ?? ''} ${parsed.style ?? ''} ${parsed.color ?? ''}`;
            s.borderLeft = `${parsed.width ?? ''} ${parsed.style ?? ''} ${parsed.color ?? ''}`;
            delete (s.border)
        }

        if (s.borderWidth || s.borderStyle || s.borderColor) {
            s.borderTop = `${s.borderWidth ?? ''} ${s.borderStyle ?? ''} ${s.borderColor ?? ''}`;
            s.borderRight = `${s.borderWidth ?? ''} ${s.borderStyle ?? ''} ${s.borderColor ?? ''}`;
            s.borderBottom = `${s.borderWidth ?? ''} ${s.borderStyle ?? ''} ${s.borderColor ?? ''}`;
            s.borderLeft = `${s.borderWidth ?? ''} ${s.borderStyle ?? ''} ${s.borderColor ?? ''}`;
            delete (s.borderWidth)
            delete (s.borderStyle)
            delete (s.borderColor)
        }

        return s;
    }, [block, view])

    const data = useMemo(() => {
        if (!block) return null
        return block.data
    }, [block])

    const actionItems = useMemo(() => {
        return Array.isArray(data?.actions) ? data.actions : [];
    }, [data?.actions]);

    const cssPropertyOptionsSorted = useMemo(() => {
        return [...cssProperties].sort((a, b) => a.name.localeCompare(b.name));
    }, []);

    const cssPropertyOptionsWithCustom = useMemo(() => {
        return [...cssPropertyOptionsSorted, { id: -1, name: 'CUSTOM', value: '__custom__' }];
    }, [cssPropertyOptionsSorted]);

    const cssPropertyValueSet = useMemo(() => {
        return new Set(cssPropertyOptionsSorted.map((property) => property.value));
    }, [cssPropertyOptionsSorted]);

    const attributeOptions = useMemo(() => {
        return [
            { id: 1, name: 'id', value: 'id' },
            { id: 2, name: 'class', value: 'class' },
            { id: 3, name: 'aria-label', value: 'aria-label' },
            { id: 4, name: 'aria-hidden', value: 'aria-hidden' },
            { id: 5, name: 'role', value: 'role' },
            { id: 6, name: 'href', value: 'href' },
            { id: 7, name: 'target', value: 'target' },
            { id: 8, name: 'rel', value: 'rel' },
            { id: 9, name: 'data-*', value: 'data-' },
        ];
    }, []);

    const attributeOptionsWithCustom = useMemo(() => {
        return [...attributeOptions, { id: -1, name: 'CUSTOM', value: '__custom__' }];
    }, [attributeOptions]);

    const attributeValueSet = useMemo(() => {
        return new Set(attributeOptions.map((option) => option.value));
    }, [attributeOptions]);

    const actionPropertySelectOptionsMap = useMemo(() => {
        const textAlignOptions = [
            { id: 1, name: 'left', value: 'left' },
            { id: 2, name: 'center', value: 'center' },
            { id: 3, name: 'right', value: 'right' },
            { id: 4, name: 'justify', value: 'justify' },
        ];
        const displayOptions = [
            { id: 1, name: 'unset', value: 'unset' },
            { id: 2, name: 'block', value: 'block' },
            { id: 3, name: 'inline', value: 'inline' },
            { id: 4, name: 'inline-block', value: 'inline-block' },
            { id: 5, name: 'flex', value: 'flex' },
            { id: 6, name: 'grid', value: 'grid' },
            { id: 7, name: 'none', value: 'none' },
        ];
        const justifyContentOptions = [
            { id: 1, name: 'flex-start', value: 'flex-start' },
            { id: 2, name: 'center', value: 'center' },
            { id: 3, name: 'flex-end', value: 'flex-end' },
            { id: 4, name: 'space-between', value: 'space-between' },
            { id: 5, name: 'space-around', value: 'space-around' },
            { id: 6, name: 'space-evenly', value: 'space-evenly' },
        ];
        const alignItemsOptions = [
            { id: 1, name: 'stretch', value: 'stretch' },
            { id: 2, name: 'flex-start', value: 'flex-start' },
            { id: 3, name: 'center', value: 'center' },
            { id: 4, name: 'flex-end', value: 'flex-end' },
            { id: 5, name: 'baseline', value: 'baseline' },
        ];
        const textTransformOptions = [
            { id: 1, name: 'none', value: 'none' },
            { id: 2, name: 'uppercase', value: 'uppercase' },
            { id: 3, name: 'lowercase', value: 'lowercase' },
            { id: 4, name: 'capitalize', value: 'capitalize' },
        ];
        const textDecorationOptions = [
            { id: 1, name: 'none', value: 'none' },
            { id: 2, name: 'underline', value: 'underline' },
            { id: 3, name: 'overline', value: 'overline' },
            { id: 4, name: 'line-through', value: 'line-through' },
        ];

        return {
            position: positionOptions,
            overflow: overflowOptions,
            'white-space': whiteSpaceOptions,
            visibility: visibilityOptions,
            cursor: cursorOptions,
            'flex-wrap': rowWrapOptions,
            'flex-direction': flexDirectionOptions,
            'object-fit': backgroundSizeOptions,
            'object-position': backgroundPositionOptions,
            'background-size': backgroundSizeOptions,
            'background-position': backgroundPositionOptions,
            'background-repeat': backgroundRepeatOptions,
            'text-align': textAlignOptions,
            'border-style': borderOptions,
            'justify-content': justifyContentOptions,
            'align-items': alignItemsOptions,
            display: displayOptions,
            'font-family': fontOptions,
            'font-weight': fontWeightOptions,
            'text-transform': textTransformOptions,
            'text-decoration': textDecorationOptions,
        };
    }, []);

    const actionUnitPropertySet = useMemo(() => {
        return new Set([
            'width', 'height', 'min-width', 'min-height', 'max-width', 'max-height',
            'top', 'right', 'bottom', 'left',
            'margin', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
            'padding', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
            'border-radius', 'border-top-left-radius', 'border-top-right-radius', 'border-bottom-left-radius', 'border-bottom-right-radius',
            'gap', 'font-size', 'line-height',
            'border-width', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width',
            'outline-width', 'letter-spacing', 'word-spacing'
        ]);
    }, []);

    const actionNumericPropertySet = useMemo(() => {
        return new Set(['opacity', 'z-index', 'order', 'flex-grow', 'flex-shrink']);
    }, []);

    const actionColorPropertySet = useMemo(() => {
        return new Set([
            'color', 'background-color',
            'border-color', 'border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color',
            'outline-color', 'text-decoration-color', 'fill', 'stroke'
        ]);
    }, []);

    const buildTransformValue = useCallback((parts) => {
        return `${parts?.translateX ? `translateX(${parts.translateX}) ` : ''} ${parts?.translateY ? `translateY(${parts.translateY}) ` : ''} ${parts?.rotate ? `rotate(${parts.rotate}) ` : ''} ${parts?.scale ? `scale(${parts.scale})` : ''}`.trim();
    }, []);

    const renderActionPropertyValueEditor = useCallback((propertyKey, value, onChange) => {
        const normalizedKey = typeof propertyKey === 'string'
            ? propertyKey
                .trim()
                .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
                .replace(/_/g, '-')
                .toLowerCase()
            : '';
        const normalizedValue = value == null ? '' : String(value);

        if (normalizedKey === 'transform') {
            const transformValue = parseTransform(normalizedValue);
            const updateTransformPart = (field, nextValue) => {
                const nextTransform = {
                    ...transformValue,
                    [field]: nextValue ?? ''
                };

                onChange(buildTransformValue(nextTransform));
            };

            return (
                <div className={styles.paddingsInner}>
                    <UnitSelector
                        value={transformValue?.translateX}
                        label={'TranslateX'}
                        onChange={(nextValue) => {
                            updateTransformPart('translateX', nextValue);
                        }}
                    />
                    <UnitSelector
                        value={transformValue?.translateY}
                        label={'TranslateY'}
                        onChange={(nextValue) => {
                            updateTransformPart('translateY', nextValue);
                        }}
                    />
                    <UnitSelector
                        value={transformValue?.rotate}
                        label={'Rotate'}
                        defaultUnit={'deg'}
                        disableUnit={true}
                        onChange={(nextValue) => {
                            updateTransformPart('rotate', nextValue);
                        }}
                    />
                    <TextInput appearance="modern"
                        type="number"
                        numberType='float'
                        placeholder={'Scale'}
                        value={transformValue?.scale}
                        onKeyUp={(nextValue) => {
                            updateTransformPart('scale', nextValue);
                        }}
                    />
                </div>
            );
        }

        const selectOptions = actionPropertySelectOptionsMap[normalizedKey];
        if (Array.isArray(selectOptions) && selectOptions.length > 0) {
            const selectedOption = selectOptions.find((option) => option.value === normalizedValue)
                ?? selectOptions.find((option) => option.value === '')
                ?? selectOptions[0];

            return (
                <Select appearance="modern"
                    options={selectOptions}
                    selected={selectedOption}
                    onSelect={(option) => {
                        onChange(option?.value ?? '');
                    }}
                />
            );
        }

        if (actionColorPropertySet.has(normalizedKey)) {
            return (
                <ColorPicker
                    className={styles.colorPicker}
                    disableDarkMode
                    width={350}
                    height={100}
                    hidePresets
                    hideAdvancedSliders
                    hideColorGuide
                    hideInputType
                    hideColorTypeBtns
                    value={normalizedValue}
                    onChange={(color) => {
                        onChange(color);
                    }}
                />
            );
        }

        if (actionUnitPropertySet.has(normalizedKey)) {
            return (
                <UnitSelector
                    value={normalizedValue}
                    label={'VALUE'}
                    onChange={(nextValue) => {
                        onChange(nextValue ?? '');
                    }}
                />
            );
        }

        if (actionNumericPropertySet.has(normalizedKey)) {
            return (
                <TextInput appearance="modern"
                    type="number"
                    numberType='float'
                    placeholder={'Value'}
                    value={normalizedValue}
                    onKeyUp={(nextValue) => {
                        onChange(nextValue);
                    }}
                />
            );
        }

        return (
            <TextInput appearance="modern"
                type="text"
                placeholder={'Value'}
                value={normalizedValue}
                onKeyUp={(nextValue) => {
                    onChange(nextValue);
                }}
            />
        );
    }, [actionColorPropertySet, actionNumericPropertySet, actionPropertySelectOptionsMap, actionUnitPropertySet, buildTransformValue]);

    const availableTargetBlocks = useMemo(() => {
        if (!Array.isArray(page)) {
            return [];
        }

        const items = [];
        const walk = (blocks) => {
            if (!Array.isArray(blocks)) {
                return;
            }

            blocks.forEach((item) => {
                if (!item || typeof item !== 'object') {
                    return;
                }

                if (item.id) {
                    items.push({
                        id: String(item.id),
                        type: item.type,
                        name: `#${item.id} · ${item.type}`,
                        value: String(item.id)
                    });
                }

                if (Array.isArray(item.content) && item.content.length > 0) {
                    walk(item.content);
                }
            });
        };

        walk(page);
        return items;
    }, [page]);

    const actionTargetOptions = useMemo(() => {
        return [
            { id: '__none__', name: 'Nessun target (vuoto)', value: '' },
            ...availableTargetBlocks
        ];
    }, [availableTargetBlocks]);

    const describeActionTarget = useCallback((target) => {
        if (!target) {
            return 'Nessun target';
        }

        const normalizedTarget = String(target);
        const existing = availableTargetBlocks.find((item) => item.id === normalizedTarget);
        if (existing) {
            return `#${existing.id} (${existing.type})`;
        }

        return `#${normalizedTarget}`;
    }, [availableTargetBlocks]);

    // useEffect to update block data.
    useEffect(() => {
        if (block && data) {
            if (!_.isEqual(block.data, data)) {
                targetBlockIds.forEach((targetId) => {
                    updateBlock(targetId, { data: data })
                })
            }
        }
    }, [data, block, targetBlockIds, updateBlock])

    useEffect(() => {
        if (!boxShadow) return;
        if (!boxShadow.hOffset || !boxShadow.vOffset || !boxShadow.blur || !boxShadow.color) {
            return
        }
        const boxShadowValue = `${boxShadow.inset ? boxShadow.inset + ' ' : ''}${boxShadow.hOffset} ${boxShadow.vOffset} ${boxShadow.blur} ${boxShadow.spread ?? '0px'} ${boxShadow.color}`;
        if (boxShadowValue !== viewStyle.boxShadow) {
            updateStyleProperty('boxShadow', boxShadowValue);
        }
    }, [boxShadow])

    useEffect(() => {
        if (!transform) return;

        const transformValue = `${transform.translateX ? `translateX(${transform.translateX}) ` : ''} ${transform.translateY ? `translateY(${transform.translateY}) ` : ''} ${transform.rotate ? `rotate(${transform.rotate}) ` : ''} ${transform.scale ? `scale(${transform.scale})` : ''}`.trim();
        if (transformValue !== viewStyle?.transform) {
            updateStyleProperty('transform', transformValue);
        }
    }, [transform])


    const applyToAllViews = (properties) => {
        targetBlockIds.forEach((targetId) => {
            const targetBlock = findBlockById(targetId);
            if (!targetBlock) {
                return;
            }
            let style = { ...(targetBlock.style ?? {}) }
            let styleTabled = { ...(targetBlock.styleTablet ?? {}) }
            let styleMobile = { ...(targetBlock.styleMobile ?? {}) }
            for (let p of properties) {
                const value = viewStyle[p] ?? 'unset';
                style[p] = value;
                styleTabled[p] = value;
                styleMobile[p] = value;
            }
            updateBlock(targetId, { style: style, styleTablet: styleTabled, styleMobile: styleMobile });
        });
    }

    const updateStyleProperty = (property, value) => {
        if (!block) return;

        targetBlockIds.forEach((targetId) => {
            const currentBlock = findBlockById(targetId);
            if (!currentBlock) {
                return;
            }

            const getTargetStyle = () => {
                switch (view) {
                    case 'desktop':
                        return { ...(currentBlock?.style ?? {}) };
                    case 'tablet':
                        return { ...(currentBlock?.styleTablet ?? {}) };
                    case 'mobile':
                        return { ...(currentBlock?.styleMobile ?? {}) };
                    default:
                        return {};
                }
            };

            const style = getTargetStyle();
            const normalizeStyleValue = (prop, nextValue) => {
                if (prop === 'display' && nextValue == null) {
                    return '';
                }
                return nextValue ?? 'unset';
            };

            if (typeof (property) === 'string') {
                style[property] = normalizeStyleValue(property, value);
            }
            else if (Array.isArray(property)) {
                for (let prop of property) {
                    style[prop] = normalizeStyleValue(prop, value);
                }
            }
            else if (typeof (property) === 'object' && property !== null) {
                for (let prop in property) {
                    style[prop] = normalizeStyleValue(prop, property[prop]);
                }
            }

            switch (view) {
                case 'desktop': {
                    const updates = { style: style };
                    if (style.display === 'none') {
                        if (currentBlock?.styleTablet?.display === undefined) {
                            updates.styleTablet = {
                                ...(currentBlock?.styleTablet ?? {}),
                                display: ''
                            };
                        }
                        if (currentBlock?.styleMobile?.display === undefined) {
                            updates.styleMobile = {
                                ...(currentBlock?.styleMobile ?? {}),
                                display: ''
                            };
                        }
                    }
                    updateBlock(targetId, updates);
                    break;
                }
                case 'tablet':
                    updateBlock(targetId, { styleTablet: style });
                    break;
                case 'mobile':
                    updateBlock(targetId, { styleMobile: style });
                    break;
                default:
                    break;
            }
        });
    }

    const updateDataProperty = (property, value) => {

        if (!block) {
            return;
        }

        const resolveBlockById = (id) => {
            if (id == null) {
                return null;
            }

            const direct = findBlockById(id);
            if (direct) {
                return direct;
            }

            const asString = findBlockById(String(id));
            if (asString) {
                return asString;
            }

            const asNumber = Number(id);
            if (!Number.isNaN(asNumber)) {
                return findBlockById(asNumber);
            }

            return null;
        };

        const primaryCandidates = targetBlockIds.length > 0
            ? targetBlockIds
            : [actionTargetSourceBlockId, block?.id, selectedBlock?.id].filter(Boolean);

        let blocksToUpdate = primaryCandidates
            .map((id) => resolveBlockById(id))
            .filter(Boolean);

        if (blocksToUpdate.length === 0) {
            blocksToUpdate = [actionTargetSourceBlockId, block?.id, selectedBlock?.id]
                .filter(Boolean)
                .map((id) => resolveBlockById(id))
                .filter(Boolean);
        }

        if (blocksToUpdate.length === 0) {
            return;
        }

        if (property == null) {
            blocksToUpdate.forEach((targetBlock) => {
                updateBlock(targetBlock.id, { data: value });
            });
            return;
        }

        const shouldDeleteProperty = value === undefined || (property === 'actions' && Array.isArray(value) && value.length === 0)

        blocksToUpdate.forEach((targetBlock) => {
            const targetData = targetBlock?.data;

            if (shouldDeleteProperty) {
                if (!_.isPlainObject(targetData)) {
                    updateBlock(targetBlock.id, { data: {} })
                    return
                }

                const nextData = { ...targetData }
                delete nextData[property]
                updateBlock(targetBlock.id, { data: nextData })
                return
            }

            if (targetBlock.type === BlockType.Image && typeof targetData === 'string') {
                updateBlock(targetBlock.id, { data: { url: targetData, [property]: value } });
                return;
            }

            if (targetBlock.type === BlockType.Collapsable && typeof targetData === 'string') {
                updateBlock(targetBlock.id, { data: { [property]: value } });
                return;
            }

            if (targetBlock.type === BlockType.HTML && typeof targetData === 'string') {
                updateBlock(targetBlock.id, { data: { [property]: value } });
                return;
            }

            if (!_.isPlainObject(targetData)) {
                updateBlock(targetBlock.id, { data: { [property]: value } });
                return;
            }

            updateBlock(targetBlock.id, { data: { ...targetData, [property]: value } });
        });
    }

    useEffect(() => {
        if (!forcedTab) {
            return;
        }
        setSelectedTab((current) => current === forcedTab ? current : forcedTab);
        onForcedTabApplied();
    }, [forcedTab, onForcedTabApplied]);


    useEffect(() => {
        onToolbarToggle(openToolbar)
    }, [openToolbar])

    useEffect(() => {
        if (block?.type !== BlockType.Form) {
            loadedAcListsRef.current = '';
            return;
        }

        const acListIds = Array.isArray(data?.ac_lists)
            ? data.ac_lists
                .map(id => parseInt(id, 10))
                .filter(id => !Number.isNaN(id))
            : [];

        if (acListIds.length === 0) {
            loadedAcListsRef.current = '';
            return;
        }

        const serializedIds = [...acListIds].sort((a, b) => a - b).join(',');
        if (loadedAcListsRef.current === serializedIds) return;

        loadedAcListsRef.current = serializedIds;
        getListsByIds(acListIds);
    }, [block, data?.ac_lists])

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, [setEyeDropActive]);

    useEffect(() => {
        onEyedropStateChange(eyeDropActive);
    }, [eyeDropActive, onEyedropStateChange]);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const EyeDropperCtor = window.EyeDropper;
        if (!EyeDropperCtor || eyeDropperPatchedRef.current) {
            return;
        }
        const prototype = EyeDropperCtor.prototype;
        if (!prototype || typeof prototype.open !== 'function') {
            return;
        }

        const originalOpen = prototype.open;
        const patchedOpen = function (...args) {
            if (isMountedRef.current) {
                setEyeDropActive(true);
            }
            const result = originalOpen.apply(this, args);
            const normalized = result && typeof result.finally === 'function'
                ? result
                : Promise.resolve(result);
            return normalized.finally(() => {
                if (isMountedRef.current) {
                    setEyeDropActive(false);
                }
            });
        };
        prototype.open = patchedOpen;

        eyeDropperPatchedRef.current = true;

        return () => {
            if (prototype.open === patchedOpen) {
                prototype.open = originalOpen;
            }
            eyeDropperPatchedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (!block || selectedTab !== 'style') {
            return;
        }

        const eyeDrops = document.querySelectorAll('#rbgcp-eyedropper-btn');
        if (!eyeDrops || eyeDrops.length === 0) {
            return;
        }

        const handleEyeDropClick = () => {
            setEyeDropActive(true)
        };

        for (let eyeDrop of eyeDrops) {
            eyeDrop.addEventListener('click', handleEyeDropClick);
        }

        return () => {
            for (let eyeDrop of eyeDrops) {
                eyeDrop.removeEventListener('click', handleEyeDropClick);
            }
        };

    }, [block, selectedTab, colorBackground, imageBackground]);

    useEffect(() => {
        if (!eyeDropActive) {
            return;
        }

        const isWithinColorPicker = (target) => {
            if (typeof Element === 'undefined') {
                return false;
            }
            if (!(target instanceof Element)) {
                return false;
            }
            return Boolean(target.closest('#rbgcp') || target.closest('.rbgcp') || target.id === 'rbgcp-eyedropper-btn');
        };

        const handlePointerDown = (event) => {
            if (isWithinColorPicker(event.target)) {
                return;
            }
            setEyeDropActive(false);
        };

        const handleKeyDown = (event) => {
            if (event.key === 'Escape' || event.key === 'Esc') {
                setEyeDropActive(false);
            }
        };

        document.addEventListener('pointerdown', handlePointerDown, true);
        document.addEventListener('keydown', handleKeyDown, true);

        return () => {
            document.removeEventListener('pointerdown', handlePointerDown, true);
            document.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [eyeDropActive]);

    const gridRows = useMemo(() => {
        switch (view) {
            case 'desktop':
                return block?.data?.grid?.rows
            case 'tablet':
                return block?.data?.breakpoints?.[768]?.grid?.rows
            case 'mobile':
                return block?.data?.breakpoints?.[540]?.grid?.rows
            default:
                return block?.data?.grid?.rows
        }
    }, [view, block])

    const gridColumns = useMemo(() => {
        switch (view) {
            case 'desktop':
                return block?.data?.grid?.cols
            case 'tablet':
                return block?.data?.breakpoints?.[768]?.grid?.cols
            case 'mobile':
                return block?.data?.breakpoints?.[540]?.grid?.cols
            default:
                return block?.data?.grid?.cols
        }
    }, [view, block])

    const perPage = useMemo(() => {
        switch (view) {
            case 'desktop':
                return data?.perPage
            case 'tablet':
                return data?.breakpoints?.[768]?.perPage ?? 2
            case 'mobile':
                return data?.breakpoints?.[540]?.perPage ?? 1
            default:
                return data?.perPage
        }
    }, [view, data])

    const perMove = useMemo(() => {
        switch (view) {
            case 'desktop':
                return block?.data?.perMove
            case 'tablet':
                return block?.data?.breakpoints?.[768]?.perMove
            case 'mobile':
                return block?.data?.breakpoints?.[540]?.perMove
            default:
                return block?.data?.perMove
        }
    }, [view, block])

    function hasNonEmptyString(...strings) {
        return strings.some(str => typeof str === 'string' && str.trim() !== '' && str.trim() !== 'unset');
    }

    const parseAspectRatio = useCallback((value) => {
        if (typeof value !== 'string') {
            return { width: '', height: '' };
        }

        const cleaned = value.trim().replace(/\s+/g, '');
        if (!cleaned || cleaned === 'auto') {
            return { width: '', height: '' };
        }

        const separator = cleaned.includes('/') ? '/' : cleaned.includes(':') ? ':' : null;
        if (!separator) {
            return { width: '', height: '' };
        }

        const [left, right] = cleaned.split(separator);
        if (!left || !right) {
            return { width: '', height: '' };
        }

        const width = parseFloat(left);
        const height = parseFloat(right);
        if (Number.isNaN(width) || Number.isNaN(height) || width <= 0 || height <= 0) {
            return { width: '', height: '' };
        }

        return { width: String(width), height: String(height) };
    }, []);

    useEffect(() => {
        const { width, height } = parseAspectRatio(viewStyle?.aspectRatio);
        setCustomAspectRatioWidth(width);
        setCustomAspectRatioHeight(height);
    }, [parseAspectRatio, viewStyle?.aspectRatio]);

    const normalizeAspectRatioValue = useCallback((value) => {
        if (typeof value !== 'string') {
            return '';
        }
        return value.trim().toLowerCase().replace(/\s+/g, '').replace(':', '/');
    }, []);

    const selectedAspectRatioOption = useMemo(() => {
        const normalizedCurrent = normalizeAspectRatioValue(viewStyle?.aspectRatio ?? '');
        const preset = aspectRatioPresetOptions.find((option) => {
            if (option.value === '__custom__') {
                return false;
            }
            return normalizeAspectRatioValue(option.value) === normalizedCurrent;
        });

        return preset ?? aspectRatioPresetOptions[aspectRatioPresetOptions.length - 1];
    }, [aspectRatioPresetOptions, normalizeAspectRatioValue, viewStyle?.aspectRatio]);

    const applyCustomAspectRatio = (rawWidth, rawHeight) => {
        const widthValue = typeof rawWidth === 'string' ? rawWidth.trim() : String(rawWidth ?? '').trim();
        const heightValue = typeof rawHeight === 'string' ? rawHeight.trim() : String(rawHeight ?? '').trim();

        if (!widthValue || !heightValue) {
            return;
        }

        const width = parseFloat(widthValue.replace(',', '.'));
        const height = parseFloat(heightValue.replace(',', '.'));

        if (Number.isNaN(width) || Number.isNaN(height) || width <= 0 || height <= 0) {
            return;
        }

        updateStyleProperty('aspectRatio', `${width} / ${height}`);
    };

    const searchLists = async (value) => {
        try {
            const lists = await api.get(`/admin/active-campaign/lists?q=${encodeURIComponent(value)}`);
            // sostituisci tutte le liste tranne quelle selezionate
            let newLists = lists.filter(list => !selectedLists.map(sl => parseInt(sl.id)).includes(parseInt(list.id)));
            setLists([...selectedLists, ...newLists]);
        }
        catch (e) {
            console.error("Error fetching lists:", e);
        }
    }

    const getListsByIds = async (ids) => {
        try {
            const lists = await api.get(`/admin/active-campaign/lists?ids=${encodeURIComponent(ids.join(','))}`);
            setLists(lists);
            setSelectedLists(lists.map(list => ({ id: parseInt(list.id), name: list.name })));
        }
        catch (e) {
            console.error("Error fetching lists by ids:", e);
        }
    }

    const acListDisabled = useMemo(() => {
        if (block && block.type !== BlockType.Form) return false;
        if (!data || !data.fields) return true;
        if (!data.fields.find(f => f.name === 'name' && f.required && ['text', 'textarea'].includes(f.type)) ||
            !data.fields.find(f => f.name === 'surname' && f.required && ['text', 'textarea'].includes(f.type)) ||
            !data.fields.find(f => f.name === 'email' && f.required && ['text', 'textarea'].includes(f.type))) {
            return true;
        }
    }, [block, data])

    useEffect(() => {
        if (!block || block.type !== BlockType.Form) return;
        if (!data || !data.fields) return;
        if (selectedLists.length === 0) return;

        const incomingIds = selectedLists.map(l => parseInt(l.id)).sort((a, b) => a - b);
        const existingIds = Array.isArray(data.ac_lists)
            ? data.ac_lists.map(id => parseInt(id)).sort((a, b) => a - b)
            : [];

        if (_.isEqual(incomingIds, existingIds)) return;

        updateDataProperty('ac_lists', incomingIds);
    }, [block, data, selectedLists])

    useEffect(() => {
        if (typeof document === 'undefined') {
            return;
        }

        const selector = `.${styles.actionButton}`;
        const buttons = document.querySelectorAll(selector);
        if (!buttons || buttons.length === 0) {
            return;
        }

        const timeoutMap = new Map();

        const handleActionClick = (event) => {
            const button = event.currentTarget;
            const label = button?.querySelector('span');
            if (!label) {
                return;
            }

            const originalText = label.dataset.originalLabel ?? label.textContent ?? '';
            label.dataset.originalLabel = originalText;
            label.textContent = 'DONE!';

            if (timeoutMap.has(button)) {
                clearTimeout(timeoutMap.get(button));
            }

            const timeoutId = window.setTimeout(() => {
                label.textContent = label.dataset.originalLabel ?? originalText;
                timeoutMap.delete(button);
            }, 2000);

            timeoutMap.set(button, timeoutId);
        };

        buttons.forEach((button) => {
            const label = button.querySelector('span');
            if (label && !label.dataset.originalLabel) {
                label.dataset.originalLabel = label.textContent ?? '';
            }
            button.addEventListener('click', handleActionClick);
        });

        return () => {
            buttons.forEach((button) => {
                button.removeEventListener('click', handleActionClick);
                const label = button.querySelector('span');
                if (label && label.dataset.originalLabel) {
                    label.textContent = label.dataset.originalLabel;
                }
            });
            timeoutMap.forEach((timeoutId) => {
                clearTimeout(timeoutId);
            });
            timeoutMap.clear();
        };
    }, [selectedBlock?.id, selectedTab, view, colorBackground, imageBackground, data?.actions?.length])

    const backgroundImageToUrl = (bg) => {
        if (!bg || bg.trim() === '') return '';
        const match = bg.match(/url\((['"]?)(.*?)\1\)/);
        return match ? match[2] : null;
    }

    const getCourses = async () => {
        try {
            let courses = await api.get("/admin/courses")
            setCourses(courses.map(c => ({ id: c.id, name: c.name, value: c.id })).sort((a, b) => a.name.localeCompare(b.name)))
        }
        catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getCourses()
    }, [])

    useEffect(() => {
        if (actionTargetPickerIndex == null) {
            setActionTargetCandidateId(null);
            return;
        }

        setActionTargetCandidateId(selectedBlock?.id ? String(selectedBlock.id) : '');
    }, [actionTargetPickerIndex, selectedBlock?.id]);

    const updateActionItem = (index, updater) => {
        if (!Array.isArray(data?.actions) || typeof updater !== 'function') {
            return;
        }

        const nextActions = data.actions.map((item, itemIndex) => {
            if (itemIndex !== index) {
                return item;
            }
            const nextItem = updater({ ...(item ?? {}) });
            return nextItem ?? item;
        });

        updateDataProperty('actions', nextActions);
    };

    const renameEntryKey = (entries, oldKey, newKey) => {
        const next = {};
        const normalizedKey = typeof newKey === 'string' ? newKey : String(newKey ?? '');

        Object.entries(entries ?? {}).forEach(([entryKey, entryValue]) => {
            if (entryKey === oldKey) {
                next[normalizedKey] = entryValue;
                return;
            }
            next[entryKey] = entryValue;
        });

        return next;
    };

    const confirmActionTargetSelection = () => {
        if (actionTargetPickerIndex == null || !actionTargetSourceBlockId) {
            return;
        }

        const sourceBlock = findBlockById(actionTargetSourceBlockId);
        if (!sourceBlock || !Array.isArray(sourceBlock?.data?.actions)) {
            return;
        }

        const nextActions = sourceBlock.data.actions.map((item, index) => {
            if (index !== actionTargetPickerIndex) {
                return item;
            }
            return {
                ...(item ?? {}),
                target: actionTargetCandidateId ?? ''
            };
        });

        updateBlock(actionTargetSourceBlockId, {
            data: {
                ...(sourceBlock.data ?? {}),
                actions: nextActions
            }
        });

        selectBlock(actionTargetSourceBlockId);

        setActionTargetPickerIndex(null);
        setActionTargetCandidateId(null);
        setActionTargetSourceBlockId(null);
    };

    const handleOpenMdxColorDialog = useCallback(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) {
            return;
        }

        const range = selection.getRangeAt(0);
        const selectedText = selection.toString();
        if (!selectedText || selectedText.trim() === '') {
            return;
        }

        const commonNode = range.commonAncestorContainer;
        const containerNode = commonNode?.nodeType === 1 ? commonNode : commonNode?.parentElement;
        const targetElement = containerNode?.closest?.('[data-mdx-color-target]') ?? null;

        if (!targetElement) {
            return;
        }

        mdxSelectedTextRef.current = selectedText;
        mdxColorTargetRef.current = {
            type: targetElement.dataset.mdxColorTarget,
            index: targetElement.dataset.mdxColorIndex
        };
        setMdxColorDialogOpen(true);
    }, []);

    const handleCloseMdxColorDialog = useCallback(() => {
        setMdxColorDialogOpen(false);
    }, []);

    const normalizeInlineFontSize = (value) => {
        if (typeof value !== 'string') {
            return '';
        }
        const trimmed = value.trim();
        if (!trimmed || trimmed === 'unset') {
            return '';
        }
        if (!/[0-9]/.test(trimmed)) {
            return '';
        }
        return trimmed;
    };

    const updateTargetMarkdown = (target, updater) => {
        if (!target?.type || typeof updater !== 'function') {
            return false;
        }

        if (target.type === 'block-body') {
            const currentMarkdown = typeof block?.data === 'string' ? block.data : '';
            const updatedMarkdown = updater(currentMarkdown);
            if (updatedMarkdown !== null) {
                updateDataProperty(null, updatedMarkdown);
                return true;
            }
            return false;
        }

        if (target.type === 'collapsable-title') {
            const currentMarkdown = typeof data?.title === 'string' ? data.title : '';
            const updatedMarkdown = updater(currentMarkdown);
            if (updatedMarkdown !== null) {
                updateDataProperty('title', updatedMarkdown);
                return true;
            }
            return false;
        }

        if (target.type === 'faq-description') {
            const currentMarkdown = typeof data?.description === 'string' ? data.description : '';
            const updatedMarkdown = updater(currentMarkdown);
            if (updatedMarkdown !== null) {
                updateDataProperty('description', updatedMarkdown);
                return true;
            }
            return false;
        }

        if (target.type === 'form-field-label') {
            const fieldIndex = Number.parseInt(target.index ?? '', 10);
            if (Number.isNaN(fieldIndex) || !Array.isArray(data?.fields) || !data.fields[fieldIndex]) {
                return false;
            }

            const currentMarkdown = typeof data.fields[fieldIndex].label === 'string'
                ? data.fields[fieldIndex].label
                : '';
            const updatedMarkdown = updater(currentMarkdown);
            if (updatedMarkdown !== null) {
                const newFields = [...data.fields];
                newFields[fieldIndex] = { ...newFields[fieldIndex], label: updatedMarkdown };
                updateDataProperty('fields', newFields);
                return true;
            }
            return false;
        }

        return false;
    };

    const handleApplyMdxInlineColor = () => {
        const selectedText = mdxSelectedTextRef.current;
        const target = mdxColorTargetRef.current;

        if (!selectedText || !target?.type) {
            setMdxColorDialogOpen(false);
            return;
        }

        const styleParts = [`color: ${mdxInlineColor};`];
        const normalizedFontSize = normalizeInlineFontSize(mdxInlineFontSize);
        if (normalizedFontSize) {
            styleParts.push(`font-size: ${normalizedFontSize};`);
        }
        if (mdxInlineFontWeight && mdxInlineFontWeight !== 'unset') {
            styleParts.push(`font-weight: ${mdxInlineFontWeight};`);
        }
        const replacement = `<span style="${styleParts.join(' ')}">${selectedText}</span>`;

        const replaceOnce = (source) => {
            if (typeof source !== 'string' || source.length === 0) {
                return null;
            }
            const index = source.indexOf(selectedText);
            if (index < 0) {
                return null;
            }
            return `${source.slice(0, index)}${replacement}${source.slice(index + selectedText.length)}`;
        };

        const hasUpdated = updateTargetMarkdown(target, replaceOnce);
        if (hasUpdated) {
            setMdxEditorRefreshNonce((previous) => previous + 1);
        }

        setMdxColorDialogOpen(false);
    };

    const handleResetMdxInlineStyle = () => {
        const selectedText = mdxSelectedTextRef.current;
        const target = mdxColorTargetRef.current;

        if (!selectedText || !target?.type) {
            setMdxColorDialogOpen(false);
            return;
        }

        const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const escapedText = escapeRegExp(selectedText);

        const unwrapStyledSpanOnce = (source) => {
            if (typeof source !== 'string' || source.length === 0) {
                return null;
            }

            const styledPattern = new RegExp(`<span\\b[^>]*style=("|')[^"']*\\1[^>]*>${escapedText}<\\/span>`);
            const plainPattern = new RegExp(`<span\\b[^>]*>${escapedText}<\\/span>`);

            if (styledPattern.test(source)) {
                return source.replace(styledPattern, selectedText);
            }
            if (plainPattern.test(source)) {
                return source.replace(plainPattern, selectedText);
            }
            return null;
        };

        const hasUpdated = updateTargetMarkdown(target, unwrapStyledSpanOnce);
        if (hasUpdated) {
            setMdxEditorRefreshNonce((previous) => previous + 1);
        }

        setMdxColorDialogOpen(false);
    };

    return (
        <>
            <div className={`${styles.toolbar} ${!openToolbar ? styles.collapsed : ''}`}>
                <div className={styles.inspectorHeading}>
                    <div><h2>Editor pagina</h2><p>Contenuti e proprietà</p></div>
                    <StyleIcon aria-hidden="true" />
                </div>
                <div className={styles.tabs} aria-label="Sezioni del builder">
                    {customTab &&
                        <button type="button" className={`${styles.tabSelector} ${selectedTab === 'custom' ? styles.selected : ''}`} aria-pressed={selectedTab === 'custom'} onClick={() => {
                            setSelectedTab('custom')
                        }}>
                            <InfoIcon className={styles.tabIcon} />
                            {customTab?.name}
                        </button>
                    }
                    <button type="button" className={`${styles.tabSelector} ${selectedTab === 'struct' ? styles.selected : ''}`} aria-pressed={selectedTab === 'struct'} onClick={() => {
                        setSelectedTab('struct')
                    }}>
                        <StructIcon className={styles.tabIcon} />
                        Struttura
                    </button>
                    <button type="button" className={`${styles.tabSelector} ${selectedTab === 'style' ? styles.selected : ''}`} aria-pressed={selectedTab === 'style'} onClick={() => {
                        setSelectedTab('style')
                    }}>
                        <StyleIcon className={styles.tabIcon} />
                        Stile
                    </button>
                </div>
                {selectedTab === 'custom' &&
                    <div className={styles.customContent}>
                        {customTab?.content}
                    </div>
                }
                {selectedTab === 'struct' &&
                    <PageBuilderStructure view={view} isPreviewMode={isPreviewMode} />
                }
                {selectedTab === 'style' &&
                    <div className={styles.content}>
                        {block &&
                            <>
                                <div className={styles.blockType}>
                                    {selectionSummaryLabel ?? block?.type}
                                    {!selectionSummaryLabel && block?.id && (
                                        <TooltipWrapper text={`#${block?.id}`}>
                                            <CopyIcon className={styles.copyIcon} onClick={async () => {
                                                if (block?.id) {
                                                    await navigator.clipboard.writeText(`#${block?.id}`)
                                                }
                                            }} />
                                        </TooltipWrapper>
                                    )}
                                </div>

                                {/* {block.type === BlockType.Text &&
                                    <Collapsable title='TEXT' appearance='modern' active={true} expanded={true}>
                                        <div className={styles.collapsibleContent}>
                                            <div className={styles.text}>
                                                <TextInput appearance="modern" type="text" placeholder={"Testo"} value={data ?? ''} onKeyUp={(v) => {
                                                    updateDataProperty('text', v)
                                                }} />
                                                <UnitSelector value={viewStyle.fontSize ?? '0.875rem'}
                                                    label={"SIZE"}
                                                    onChange={(v) => {
                                                        updateStyleProperty('fontSize', v)
                                                    }} />
                                                <UnitSelector value={viewStyle.lineHeight}
                                                    label={"LINE HEIGHT"}
                                                    onChange={(v) => {
                                                        updateStyleProperty('lineHeight', v)
                                                    }} />
                                                <Select appearance="modern" options={fontOptions} selected={fontOptions.find(o => o.value === viewStyle.fontFamily) ?? fontOptions[0]} onSelect={(option) => {
                                                    updateStyleProperty('fontFamily', option.value)
                                                }} />
                                                <Select appearance="modern" options={fontWeightOptions} selected={fontWeightOptions.find(o => o.value === viewStyle.fontWeight) ?? fontWeightOptions[2]} onSelect={(option) => {
                                                    updateStyleProperty('fontWeight', option.value)
                                                }} />
                                                <div className={typo.caption}>ALIGNMENT</div>
                                                <div className={styles.alignments}>
                                                    <TextAlignLeft className={`${styles.alignIcon} ${viewStyle.textAlign === 'left' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'left')
                                                    }} />
                                                    <TextAlignRight className={`${styles.alignIcon} ${viewStyle.textAlign === 'right' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'right')
                                                    }} />
                                                    <TextAlignCenter className={`${styles.alignIcon} ${viewStyle.textAlign === 'center' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'center')
                                                    }} />
                                                    <TextAlignJustify className={`${styles.alignIcon} ${viewStyle.textAlign === 'justify' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'justify')
                                                    }} />
                                                </div>
                                                <div className={typo.caption}>STYLE</div>
                                                <div className={styles.alignments}>
                                                    <TextItalic className={`${styles.alignIcon} ${viewStyle.fontStyle === 'italic' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('fontStyle', viewStyle.fontStyle === 'italic' ? 'normal' : 'italic')
                                                    }} />
                                                    <TextUppercase className={`${styles.alignIcon} ${viewStyle.textTransform === 'uppercase' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textTransform', viewStyle.textTransform === 'uppercase' ? '' : 'uppercase')
                                                    }} />
                                                    <TextLowercase className={`${styles.alignIcon} ${viewStyle.textTransform === 'lowercase' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textTransform', viewStyle.textTransform === 'lowercase' ? '' : 'lowercase')
                                                    }} />
                                                    <TextCapitalize className={`${styles.alignIcon} ${viewStyle.textTransform === 'capitalize' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textTransform', viewStyle.textTransform === 'capitalize' ? '' : 'capitalize')
                                                    }} />
                                                    <TextUnderline className={`${styles.alignIcon} ${viewStyle.textDecoration === 'underline' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textDecoration', viewStyle.textDecoration === 'underline' ? '' : 'underline')
                                                    }} />
                                                    <TextOverline className={`${styles.alignIcon} ${viewStyle.textDecoration === 'overline' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textDecoration', viewStyle.textDecoration === 'overline' ? '' : 'overline')
                                                    }} />
                                                    <TextLinethrough className={`${styles.alignIcon} ${viewStyle.textDecoration === 'line-through' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textDecoration', viewStyle.textDecoration === 'line-through' ? '' : 'line-through')
                                                    }} />
                                                </div>
                                                <div className={typo.caption}>COLOR</div>
                                                <ColorPicker className={styles.cp} hideColorTypeBtns disableDarkMode width={350} hidePresets hideAdvancedSliders hideColorGuide hideInputType value={viewStyle.color} onChange={(color) => {
                                                    updateStyleProperty('color', color)
                                                }} />
                                                <div className={styles.themeColors}>
                                                    <Each of={themeColors} render={(color, index) => {
                                                        return (
                                                            <TooltipWrapper text={`${color.hex}`}>
                                                                <div onClick={() => {
                                                                    updateStyleProperty('color', color.value)
                                                                }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                            </TooltipWrapper>
                                                        )
                                                    }} />
                                                </div>
                                                {renderUsedPageColors((colorValue) => {
                                                    updateStyleProperty('color', colorValue)
                                                })}
                                            </div>
                                        </div>
                                    </Collapsable>
                                } */}
                                {[BlockType.Markdown, BlockType.Text].includes(block.type) &&
                                    <>
                                        <Collapsable title='MARKDOWN' appearance='modern' active={true} expanded={true}>
                                            <div className={styles.collapsibleContent}>
                                                <div className={styles.editor} data-mdx-color-target="block-body">
                                                    <MDXEditor
                                                        key={`block-body-${block.id}-${mdxEditorRefreshNonce}`}
                                                        className={styles.markdown}
                                                        markdown={typeof block.data === 'string' ? block.data : ''}
                                                        onChange={(md) => {
                                                            updateDataProperty(null, md)
                                                        }}
                                                        plugins={[
                                                            headingsPlugin(),
                                                            listsPlugin(),
                                                            quotePlugin(),
                                                            thematicBreakPlugin(),
                                                            linkDialogPlugin(),
                                                            diffSourcePlugin(),
                                                            tablePlugin(),
                                                            toolbarPlugin({
                                                                toolbarContents: () => (
                                                                    <>
                                                                        {' '}
                                                                        <UndoRedo />
                                                                        <Separator />
                                                                        <BoldItalicUnderlineToggles />
                                                                        <MdxInlineColorButton onOpen={handleOpenMdxColorDialog} />
                                                                        <Separator />
                                                                        <ListsToggle />
                                                                        <CreateLink />
                                                                        {/* <InsertTable /> */}
                                                                        <Separator />
                                                                        <BlockTypeSelect />
                                                                        <DiffSourceToggleWrapper options={["rich-text", "source"]} />
                                                                    </>
                                                                )
                                                            })
                                                        ]}
                                                    />
                                                </div>
                                                <Select appearance="modern" options={fontOptions} selected={fontOptions.find(o => o.value === viewStyle.fontFamily) ?? fontOptions[1]} onSelect={(option) => {
                                                    updateStyleProperty('fontFamily', option.value)
                                                }} />
                                                <Select appearance="modern" options={fontWeightOptions} selected={fontWeightOptions.find(o => o.value === viewStyle.fontWeight) ?? fontWeightOptions[2]} onSelect={(option) => {
                                                    updateStyleProperty('fontWeight', option.value)
                                                }} />
                                                <div className={styles.selectorsRow}>
                                                    <UnitSelector value={viewStyle.fontSize}
                                                        label={"SIZE"}
                                                        onChange={(v) => {
                                                            updateStyleProperty('fontSize', v)
                                                        }} />
                                                    <UnitSelector value={viewStyle.lineHeight}
                                                        label={"LINE HEIGHT"}
                                                        onChange={(v) => {
                                                            updateStyleProperty('lineHeight', v)
                                                        }} />
                                                </div>
                                                <div className={styles.alignments}>
                                                    <TextAlignLeft className={`${styles.alignIcon} ${viewStyle.textAlign === 'left' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'left')
                                                    }} />
                                                    <TextAlignRight className={`${styles.alignIcon} ${viewStyle.textAlign === 'right' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'right')
                                                    }} />
                                                    <TextAlignCenter className={`${styles.alignIcon} ${viewStyle.textAlign === 'center' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'center')
                                                    }} />
                                                    <TextAlignJustify className={`${styles.alignIcon} ${viewStyle.textAlign === 'justify' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'justify')
                                                    }} />
                                                </div>
                                                <ColorPicker
                                                    className={styles.colorPicker}
                                                    width={350}
                                                    height={100}
                                                    disableDarkMode
                                                    hidePresets
                                                    hideAdvancedSliders
                                                    hideColorGuide
                                                    hideInputType
                                                    hideColorTypeBtns
                                                    value={viewStyle.color}
                                                    onChange={(color) => {
                                                        updateStyleProperty('color', color)
                                                    }} />
                                                <div className={styles.themeColors}>
                                                    <Each of={themeColors} render={(color, index) => {
                                                        return (
                                                            <TooltipWrapper text={`${color.hex}`}>
                                                                <div onClick={() => {
                                                                    updateStyleProperty('color', color.value)
                                                                }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                            </TooltipWrapper>
                                                        )
                                                    }} />
                                                </div>
                                                {renderUsedPageColors((colorValue) => {
                                                    updateStyleProperty('color', colorValue)
                                                })}

                                            </div>
                                            <div className={styles.actions}>
                                                <div className={styles.actionButton} onClick={() => {
                                                    updateStyleProperty({ fontFamily: null, fontWeight: null, fontSize: null, lineHeight: null, textAlign: null, color: null, fontStyle: null, textTransform: null, textDecoration: null })
                                                }}>
                                                    <ResetIcon className={styles.actionIcon} />
                                                    <span>RESET</span>
                                                </div>
                                                <div className={styles.actionButton} onClick={() => {
                                                    applyToAllViews(['fontFamily', 'fontWeight', 'textAlign', 'color', 'fontStyle', 'textTransform', 'textDecoration'])
                                                }}>
                                                    <ApplyAllIcon className={styles.actionIcon} />
                                                    <span>APPLY TO ALL</span>
                                                </div>
                                            </div>
                                        </Collapsable>
                                    </>
                                }
                                {block.type === BlockType.Image &&
                                    <div className={styles.image}>
                                        <Collapsable title="Image" appearance='modern' active={true} expanded={true} >
                                            <TextInput appearance="modern" type="text" placeholder={"url"} value={data?.url ?? data ?? ''} onKeyUp={(v) => {
                                                updateDataProperty('url', v)
                                            }} />
                                            <div className={styles.uploader}>
                                                <Uploader
                                                    preview={data?.url ?? data ?? ''}
                                                    multiple={false}
                                                    iconButtons={true}
                                                    type={FileType.Image}
                                                    onComplete={(uploads) => {
                                                        updateDataProperty('url', uploads[0].url)
                                                    }}
                                                    onDelete={() => {

                                                    }}
                                                />
                                            </div>
                                        </Collapsable>
                                        <Collapsable title="Image Mobile" appearance='modern' active={true} expanded={true} >
                                            <TextInput appearance="modern" type="text" placeholder={"url"} value={data?.urlMobile ?? data?.url ?? data ?? ''} onKeyUp={(v) => {
                                                updateDataProperty('urlMobile', v)
                                            }} />
                                            <div className={styles.uploader}>
                                                <Uploader
                                                    preview={data?.urlMobile ?? data?.url ?? data ?? ''}
                                                    multiple={false}
                                                    iconButtons={true}
                                                    type={FileType.Image}
                                                    onComplete={(uploads) => {
                                                        updateDataProperty('urlMobile', uploads[0].url)
                                                    }}
                                                    onDelete={() => {

                                                    }}
                                                />
                                            </div>
                                        </Collapsable>
                                        <TextInput appearance="modern" type="text" placeholder={"Testo Alternativo"} value={data?.alt ?? ''} onKeyUp={(v) => {
                                            updateDataProperty('alt', v)
                                        }} />
                                        <div className={styles.toggle}>
                                            <Checkbox size="20px" label="Hero Image" labelPosition='end' radius="6px" value={data?.is_hero ?? false} style={{ maxHeight: '20px' }}
                                                onChange={(checked) => {
                                                    updateDataProperty('is_hero', checked)
                                                }} />
                                        </div>
                                        <div className={typo.caption}>SIZE</div>
                                        <Select appearance="modern" options={backgroundSizeOptions} selected={backgroundSizeOptions.find(o => o.value === viewStyle.objectFit) ?? backgroundSizeOptions[0]} onSelect={(option) => {
                                            updateStyleProperty('objectFit', option.value)
                                        }} />
                                        <div className={typo.caption}>POSITION</div>
                                        <Select appearance="modern" options={backgroundPositionOptions} selected={backgroundPositionOptions.find(o => o.value === viewStyle.objectPosition) ?? backgroundPositionOptions[0]} onSelect={(option) => {
                                            updateStyleProperty('objectPosition', option.value)
                                        }} />
                                        <div className={typo.caption}>PRIORITÀ</div>
                                        <Select appearance="modern" options={fetchPriorityOptions} selected={fetchPriorityOptions.find(o => o.value === data?.fetchPriority) ?? fetchPriorityOptions[0]} onSelect={(option) => {
                                            updateDataProperty('fetchPriority', option.value)
                                        }} />
                                        <div className={typo.caption}>CARICAMENTO</div>
                                        <Select appearance="modern" options={imageLoadingOptions} selected={imageLoadingOptions.find(o => o.value === data?.loading) ?? imageLoadingOptions[0]} onSelect={(option) => {
                                            updateDataProperty('loading', option.value)
                                        }} />
                                    </div>
                                }
                                {block.type === BlockType.Video &&
                                    <Collapsable title='VIDEO' appearance='modern' active={true} expanded={true}>
                                        <div className={styles.collapsibleContent}>
                                            <div className={styles.image}>
                                                <TextInput appearance="modern" type="text" placeholder={"video url"} value={data?.url} onKeyUp={(v) => {
                                                    updateDataProperty(null, { url: v, thumbnail: data?.thumbnail })
                                                }} />
                                                <div className={styles.uploader}>
                                                    <Uploader
                                                        key={`video-uploader-${block.id}`}
                                                        preview={data?.url}
                                                        multiple={false}
                                                        iconButtons={true}
                                                        type={FileType.Video}
                                                        onStart={(uploadData) => {
                                                            // Handle start of upload
                                                        }}
                                                        onProgress={(totalProgress, uploads) => {
                                                            // Handle progress updates
                                                        }}
                                                        onComplete={(uploads) => {
                                                            updateDataProperty(null, { url: uploads[0].url, thumbnail: data?.thumbnail })
                                                        }}
                                                        onDelete={() => {
                                                            updateDataProperty(null, { url: null, thumbnail: data?.thumbnail })
                                                        }}
                                                    />
                                                </div>
                                                <TextInput appearance="modern" type="text" placeholder={"thumbnail url"} value={data?.thumbnail} onKeyUp={(v) => {
                                                    updateDataProperty(null, { url: data?.url, thumbnail: v })
                                                }} />
                                                <div className={styles.uploader}>
                                                    <Uploader
                                                        preview={data?.thumbnail ?? block?.data?.thumbnail}
                                                        multiple={false}
                                                        iconButtons={true}
                                                        type={FileType.Image}
                                                        onComplete={(uploads) => {
                                                            updateDataProperty(null, { url: data.url, thumbnail: uploads[0].url })
                                                        }}
                                                        onDelete={() => {
                                                            updateDataProperty(null, { url: data.url, thumbnail: null })
                                                        }}
                                                    />
                                                </div>
                                                <Select appearance="modern" options={backgroundSizeOptions} selected={backgroundSizeOptions.find(o => o.value === viewStyle.objectFit) ?? backgroundSizeOptions[0]} onSelect={(option) => {
                                                    updateStyleProperty('objectFit', option.value)
                                                }} />
                                                <div className={styles.selectorsRow}>
                                                    <div className={styles.toggle}>
                                                        <Checkbox size="20px" label="Autoplay" labelPosition='end' radius="6px" value={data?.autoplay ?? false} style={{ maxHeight: '20px' }}
                                                            onChange={(checked) => {
                                                                updateDataProperty('autoplay', checked)
                                                            }} />
                                                    </div>
                                                    <div className={styles.toggle}>
                                                        <Checkbox size="20px" label="Controls" labelPosition='end' radius="6px" value={data?.controls ?? false} style={{ maxHeight: '20px' }}
                                                            onChange={(checked) => {
                                                                updateDataProperty('controls', checked)
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className={styles.selectorsRow}>
                                                    <div className={styles.toggle}>
                                                        <Checkbox size="20px" label="Muted" labelPosition='end' radius="6px" value={data?.muted ?? false} style={{ maxHeight: '20px' }}
                                                            onChange={(checked) => {
                                                                updateDataProperty('muted', checked)
                                                            }} />
                                                    </div>
                                                    <div className={styles.toggle}>
                                                        <Checkbox size="20px" label="Loop" labelPosition='end' radius="6px" value={data?.loop ?? false} style={{ maxHeight: '20px' }}
                                                            onChange={(checked) => {
                                                                updateDataProperty('loop', checked)
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className={styles.selectorsRow}>
                                                    <div className={styles.toggle}>
                                                        <Checkbox size="20px" label="Plays inline" labelPosition='end' radius="6px" value={data?.playsInline ?? false} style={{ maxHeight: '20px' }}
                                                            onChange={(checked) => {
                                                                updateDataProperty('playsInline', checked)
                                                            }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Collapsable>
                                }
                                {block.type === BlockType.Button &&
                                    <Collapsable title='BUTTON' appearance='modern' active={true} expanded={true}>
                                        <div className={styles.collapsibleContent}>
                                            <div className={styles.button}>
                                                <TextInput appearance="modern" type="text" placeholder={"Testo di default"} value={data?.text ?? ''} onKeyUp={(v) => {
                                                    updateDataProperty('text', v)
                                                }} />
                                                <TextInput appearance="modern" type="text" placeholder={"Testo accessibilità"} value={data?.ariaLabel ?? ''} onKeyUp={(v) => {
                                                    updateDataProperty('ariaLabel', v)
                                                }} />
                                                <Select appearance="modern" options={buttonTypeOptions} selected={buttonTypeOptions.find(o => o.value === (data?.on_click ?? 'navigate_to'))} onSelect={(option) => {
                                                    if (option.value === 'navigate_back') {
                                                        updateDataProperty(null, { on_click: option.value, url: '-1' })
                                                    }
                                                    else {
                                                        updateDataProperty('on_click', option.value)
                                                    }
                                                }} />
                                                {data?.on_click === 'navigate_to' &&
                                                    <>
                                                        <TextInput appearance="modern" type="text" placeholder={"Link"} value={data?.url ?? ''} onKeyUp={(v) => {
                                                            updateDataProperty('url', v)
                                                        }} />
                                                    </>
                                                }

                                                <>
                                                    <Select appearance="modern" options={buttonAppearanceOptions} selected={data?.appearance === 'default' && data?.inverse ? buttonAppearanceOptions.find(o => o.value === 'outlined') : buttonAppearanceOptions.find(o => o.value === data?.appearance) ?? buttonAppearanceOptions[0]} onSelect={(option) => {
                                                        if (option.value === 'outlined') {
                                                            updateDataProperty(null, { appearance: 'default', inverse: true })
                                                        }
                                                        else {
                                                            updateDataProperty(null, { appearance: option.value, inverse: false })
                                                        }
                                                    }} />
                                                </>

                                                <Select appearance="modern" options={fontOptions} selected={fontOptions.find(o => o.value === viewStyle.fontFamily) ?? fontOptions[fontOptions.length - 1]} onSelect={(option) => {
                                                    updateStyleProperty('fontFamily', option.value)
                                                }} />
                                                <UnitSelector value={viewStyle.fontSize}
                                                    label={"FONT SIZE"}
                                                    onChange={(v) => {
                                                        updateStyleProperty('fontSize', v)
                                                    }} />
                                                <Select appearance="modern" options={fontWeightOptions} selected={fontWeightOptions.find(o => o.value === viewStyle.fontWeight) ?? fontWeightOptions[2]} onSelect={(option) => {
                                                    updateStyleProperty('fontWeight', option.value)
                                                }} />
                                                <div className={styles.alignments}>
                                                    <TextItalic className={`${styles.alignIcon} ${viewStyle.fontStyle === 'italic' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('fontStyle', viewStyle.fontStyle === 'italic' ? 'normal' : 'italic')
                                                    }} />
                                                    <TextUppercase className={`${styles.alignIcon} ${viewStyle.textTransform === 'uppercase' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textTransform', viewStyle.textTransform === 'uppercase' ? '' : 'uppercase')
                                                    }} />
                                                    <TextLowercase className={`${styles.alignIcon} ${viewStyle.textTransform === 'lowercase' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textTransform', viewStyle.textTransform === 'lowercase' ? '' : 'lowercase')
                                                    }} />
                                                    <TextCapitalize className={`${styles.alignIcon} ${viewStyle.textTransform === 'capitalize' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textTransform', viewStyle.textTransform === 'capitalize' ? '' : 'capitalize')
                                                    }} />
                                                    <TextUnderline className={`${styles.alignIcon} ${viewStyle.textDecoration === 'underline' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textDecoration', viewStyle.textDecoration === 'underline' ? '' : 'underline')
                                                    }} />
                                                    <TextOverline className={`${styles.alignIcon} ${viewStyle.textDecoration === 'overline' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textDecoration', viewStyle.textDecoration === 'overline' ? '' : 'overline')
                                                    }} />
                                                    <TextLinethrough className={`${styles.alignIcon} ${viewStyle.textDecoration === 'line-through' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textDecoration', viewStyle.textDecoration === 'line-through' ? '' : 'line-through')
                                                    }} />
                                                </div>

                                                <div className={styles.icon}>
                                                    <div className={styles.selectorsRow}>
                                                        <div style={{ position: 'relative', width: 'fit-content' }}>
                                                            {data?.icon &&
                                                                <div className={styles.iconSVG}
                                                                    dangerouslySetInnerHTML={{ __html: data.icon.data.replaceAll("currentColor", "#212121") }}
                                                                    onClick={() => { setIconsDialogOpen(true) }}>
                                                                </div>
                                                            }{
                                                                !data?.icon &&
                                                                <div className={styles.noIcon} onClick={() => { setIconsDialogOpen(true) }}></div>
                                                            }
                                                            <CloseIcon className={styles.removeIcon} onClick={(e) => {
                                                                e.stopPropagation()
                                                                updateDataProperty('icon', null)
                                                            }} />
                                                        </div>

                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                                            <Select appearance="modern" options={iconPositionOptions} selected={iconPositionOptions.find(o => o.value === data?.icon?.position) ?? iconPositionOptions[0]} onSelect={(option) => {
                                                                if (['left', 'right'].includes(option.value)) {
                                                                    updateDataProperty('icon', { ...data?.icon, position: option.value })
                                                                    updateStyleProperty('flexDirection', 'row')
                                                                }
                                                                else {
                                                                    updateDataProperty('icon', { ...data?.icon, position: option.value })
                                                                    updateStyleProperty('flexDirection', 'column')
                                                                }
                                                            }} />
                                                            <div className={styles.paddingsInner}>
                                                                <TextInput appearance="modern" type="text" placeholder={"width"} value={data?.icon?.style?.width} onKeyUp={(v) => {
                                                                    updateDataProperty('icon', { ...data?.icon, style: { ...data?.icon?.style, width: v } })
                                                                }} />
                                                                <TextInput appearance="modern" type="text" placeholder={"height"} value={data?.icon?.style?.height} onKeyUp={(v) => {
                                                                    updateDataProperty('icon', { ...data?.icon, style: { ...data?.icon?.style, height: v } })
                                                                }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={typo.caption} style={{ paddingTop: '1rem' }}>BACKGROUND COLOR</div>
                                                <ColorPicker
                                                    className={styles.colorPicker}
                                                    disableDarkMode
                                                    width={350}
                                                    height={100}
                                                    hidePresets
                                                    hideAdvancedSliders
                                                    hideColorGuide
                                                    hideInputType
                                                    hideColorTypeBtns
                                                    value={data?.accentColor}
                                                    onChange={(color) => {
                                                        updateDataProperty('accentColor', color)
                                                    }} />
                                                <div className={styles.themeColors}>
                                                    <Each of={themeColors} render={(color, index) => {
                                                        return (
                                                            <TooltipWrapper text={`${color.hex}`}>
                                                                <div onClick={() => {
                                                                    updateDataProperty('accentColor', color.value)
                                                                }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                            </TooltipWrapper>
                                                        )
                                                    }} />
                                                </div>
                                                {renderUsedPageColors((colorValue) => {
                                                    updateDataProperty('accentColor', colorValue)
                                                })}

                                                <div className={typo.caption} style={{ paddingTop: '1rem' }}>TEXT COLOR</div>
                                                <ColorPicker
                                                    className={styles.colorPicker}
                                                    disableDarkMode
                                                    width={350}
                                                    height={100}
                                                    hidePresets
                                                    hideAdvancedSliders
                                                    hideColorGuide
                                                    hideInputType
                                                    hideColorTypeBtns
                                                    value={data?.textColor}
                                                    onChange={(color) => {
                                                        updateDataProperty('textColor', color)
                                                    }} />
                                                <div className={styles.themeColors}>
                                                    <Each of={themeColors} render={(color, index) => {
                                                        return (
                                                            <TooltipWrapper text={`${color.hex}`}>
                                                                <div onClick={() => {
                                                                    updateDataProperty('textColor', color.value)
                                                                }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                            </TooltipWrapper>
                                                        )
                                                    }} />
                                                </div>
                                                {renderUsedPageColors((colorValue) => {
                                                    updateDataProperty('textColor', colorValue)
                                                })}
                                            </div>
                                        </div>
                                    </Collapsable>
                                }
                                {block.type === BlockType.Row &&
                                    <div className={styles.row}>
                                        <Select appearance="modern" options={rowWrapOptions} selected={rowWrapOptions.find(o => o.value === viewStyle.flexWrap) ?? rowWrapOptions[0]} onSelect={(option) => {
                                            updateStyleProperty('flexWrap', option.value)
                                        }} />
                                        <Select appearance="modern" options={flexDirectionOptions} selected={flexDirectionOptions.find(o => o.value === viewStyle.flexDirection) ?? flexDirectionOptions[0]} onSelect={(option) => {
                                            updateStyleProperty('flexDirection', option.value)
                                        }} />
                                    </div>
                                }
                                {block.type === BlockType.Collapsable &&
                                    <Collapsable title='COLLAPSABLE' appearance='modern' active={true} expanded={true}>
                                        <div className={styles.collapsibleContent}>
                                            <div className={styles.text}>
                                                <div className={styles.editor} data-mdx-color-target="collapsable-title">
                                                    <MDXEditor
                                                        key={`collapsable-title-${block.id}-${mdxEditorRefreshNonce}`}
                                                        className={styles.markdown}
                                                        markdown={typeof data?.title === 'string' ? data.title : ''}
                                                        onChange={(md) => {
                                                            updateDataProperty('title', md ?? '')
                                                        }}
                                                        plugins={[
                                                            headingsPlugin(),
                                                            listsPlugin(),
                                                            quotePlugin(),
                                                            thematicBreakPlugin(),
                                                            linkDialogPlugin(),
                                                            diffSourcePlugin(),
                                                            tablePlugin(),
                                                            toolbarPlugin({
                                                                toolbarContents: () => (
                                                                    <>
                                                                        <UndoRedo />
                                                                        <Separator />
                                                                        <BoldItalicUnderlineToggles />
                                                                        <MdxInlineColorButton onOpen={handleOpenMdxColorDialog} />
                                                                        <Separator />
                                                                        <ListsToggle />
                                                                        <CreateLink />
                                                                        <Separator />
                                                                        <BlockTypeSelect />
                                                                        <DiffSourceToggleWrapper options={["rich-text", "source"]} />
                                                                    </>
                                                                )
                                                            })
                                                        ]}
                                                    />
                                                </div>
                                                <UnitSelector value={viewStyle?.fontSize}
                                                    label={"SIZE"}
                                                    onChange={(v) => {
                                                        updateStyleProperty('fontSize', v)
                                                    }} />
                                                <UnitSelector value={viewStyle?.lineHeight}
                                                    label={"LINE HEIGHT"}
                                                    onChange={(v) => {
                                                        updateStyleProperty('lineHeight', v)
                                                    }} />
                                                <Select appearance="modern" options={fontOptions} selected={fontOptions.find(o => o.value === viewStyle?.fontFamily) ?? fontOptions[0]} onSelect={(option) => {
                                                    updateStyleProperty('fontFamily', option.value)
                                                }} />
                                                <Select appearance="modern" options={fontWeightOptions} selected={fontWeightOptions.find(o => o.value === viewStyle?.fontWeight) ?? fontWeightOptions[2]} onSelect={(option) => {
                                                    updateStyleProperty('fontWeight', option.value)
                                                }} />
                                                <div className={typo.caption}>ALIGNMENT</div>
                                                <div className={styles.alignments}>
                                                    <TextAlignLeft className={`${styles.alignIcon} ${viewStyle?.textAlign === 'left' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'left')
                                                    }} />
                                                    <TextAlignRight className={`${styles.alignIcon} ${viewStyle?.textAlign === 'right' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'right')
                                                    }} />
                                                    <TextAlignCenter className={`${styles.alignIcon} ${viewStyle?.textAlign === 'center' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'center')
                                                    }} />
                                                    <TextAlignJustify className={`${styles.alignIcon} ${viewStyle?.textAlign === 'justify' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textAlign', 'justify')
                                                    }} />
                                                </div>
                                                <div className={typo.caption}>STYLE</div>
                                                <div className={styles.alignments}>
                                                    <TextItalic className={`${styles.alignIcon} ${viewStyle?.fontStyle === 'italic' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('fontStyle', viewStyle?.fontStyle === 'italic' ? 'normal' : 'italic')
                                                    }} />
                                                    <TextUppercase className={`${styles.alignIcon} ${viewStyle?.textTransform === 'uppercase' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textTransform', viewStyle?.textTransform === 'uppercase' ? '' : 'uppercase')
                                                    }} />
                                                    <TextLowercase className={`${styles.alignIcon} ${viewStyle?.textTransform === 'lowercase' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textTransform', viewStyle?.textTransform === 'lowercase' ? '' : 'lowercase')
                                                    }} />
                                                    <TextCapitalize className={`${styles.alignIcon} ${viewStyle?.textTransform === 'capitalize' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textTransform', viewStyle?.textTransform === 'capitalize' ? '' : 'capitalize')
                                                    }} />
                                                    <TextUnderline className={`${styles.alignIcon} ${viewStyle?.textDecoration === 'underline' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textDecoration', viewStyle?.textDecoration === 'underline' ? '' : 'underline')
                                                    }} />
                                                    <TextOverline className={`${styles.alignIcon} ${viewStyle?.textDecoration === 'overline' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textDecoration', viewStyle?.textDecoration === 'overline' ? '' : 'overline')
                                                    }} />
                                                    <TextLinethrough className={`${styles.alignIcon} ${viewStyle?.textDecoration === 'line-through' ? styles.selected : ''}`} onClick={() => {
                                                        updateStyleProperty('textDecoration', viewStyle?.textDecoration === 'line-through' ? '' : 'line-through')
                                                    }} />
                                                </div>
                                                <div className={typo.caption}>COLOR</div>
                                                <ColorPicker
                                                    height={100}
                                                    className={styles.colorPicker}
                                                    disableDarkMode
                                                    width={350} hidePresets hideAdvancedSliders hideColorGuide hideColorTypeBtns hideInputType value={viewStyle?.color} onChange={(color) => {
                                                        updateStyleProperty('color', color)
                                                    }} />

                                                <div className={styles.themeColors}>
                                                    <Each of={themeColors} render={(color, index) => {
                                                        return (
                                                            <TooltipWrapper text={`${color.hex}`}>
                                                                <div onClick={() => {
                                                                    updateStyleProperty('color', color.value)
                                                                }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                            </TooltipWrapper>
                                                        )
                                                    }} />
                                                </div>
                                                {renderUsedPageColors((colorValue) => {
                                                    updateStyleProperty('color', colorValue)
                                                })}
                                            </div>
                                        </div>
                                    </Collapsable>
                                }
                                {block.type === BlockType.HTML &&
                                    <div className={styles.editor}>
                                        {!isMultiSelection && <HtmlImageEditor key={`image-${block.id}`} block={block} />}
                                        {!isMultiSelection && <HtmlTextEditor key={`text-${block.id}`} block={block} view={view} />}
                                        {!isMultiSelection && <HtmlCtaEditor key={block.id} block={block} />}
                                        <details className={styles.codeSection}>
                                        <summary>Codice HTML e CSS<span>Modifica sorgente</span></summary>
                                        <label className={styles.htmlCodeLabel} htmlFor="page-builder-html-code">
                                            HTML e CSS
                                        </label>
                                        <p id="page-builder-html-help" className={styles.htmlCodeHelp}>
                                            Incolla il codice HTML e il CSS racchiuso in {'<style>...</style>'}.
                                            Usa classi specifiche per questo blocco per evitare di modificare altri elementi della pagina.
                                        </p>
                                        <HtmlCodeEditor
                                            key={block.id ?? 'html-multi-selection'}
                                            id="page-builder-html-code"
                                            describedBy="page-builder-html-help"
                                            value={typeof data?.html === 'string' ? data.html : ''}
                                            onChange={value => updateDataProperty('html', value)}
                                        />
                                        </details>
                                    </div>
                                }
                                {block.type === BlockType.Form &&
                                    <>
                                        <TextInput appearance="modern" type={"text"} placeholder={"Bottone"} label={"Bottone"} value={data?.sendLabel} onKeyUp={(v) => {
                                            updateDataProperty('sendLabel', v)
                                        }} />
                                        {acListDisabled &&
                                            <div className={typo.caption} style={{ color: 'var(--sf-red)' }}>
                                                Per associare una lista è necessario che la form contenga i campi name, surname e email di tipo testo.
                                            </div>
                                        }
                                        <TextInput appearance="modern" type={"text"} placeholder={"Form Type"} label={"Form Type"} value={data?.formType} onKeyUp={(v) => {
                                            updateDataProperty('formType', v);
                                        }} />
                                        <MultipleSelect appearance="modern"
                                            disabled={acListDisabled}
                                            placeholder="Liste Active Campaign"
                                            selected={lists?.filter(list => selectedLists.map(sl => parseInt(sl.id)).includes(parseInt(list.id)))}
                                            onSelect={(items) => {
                                                setSelectedLists(items.map(i => ({ id: parseInt(i.id), name: i.name })));
                                                updateDataProperty('ac_lists', items.map(i => parseInt(i.id)));
                                            }}
                                            searchPlaceholder="Cerca per nome"
                                            onSearch={searchLists}
                                            options={lists} />
                                        <Collapsable expanded={true} title="CAMPI" appearance='modern' active={data?.fields && data.fields.length > 0}>
                                            <div className={styles.paddingsInner} style={{ width: '100%' }}>
                                                <div className={styles.form}>
                                                    {data?.fields && data?.fields.length > 0 &&
                                                        <div className={styles.formFields}>
                                                            <ReactSortable list={data.fields} className={styles.formFieldsList} setList={(orderedFields) => {
                                                                //setto il campo position sull'index
                                                                const positionedFields = orderedFields.map((f, index) => {
                                                                    f.position = index
                                                                    return f
                                                                })
                                                                updateDataProperty('fields', positionedFields);
                                                            }}>
                                                                <Each of={data.fields} render={(field, index) => {
                                                                    return (
                                                                        <div className={`${styles.formField} ${field.expanded ? styles.expanded : ''}`}
                                                                            key={`form-field-${index}`}
                                                                        >

                                                                            {!field.expanded &&
                                                                                <div className={styles.fieldPreview}>
                                                                                    <div className={typo.caption}><b>{field.name}</b> ({field.type.toUpperCase()})</div>
                                                                                    <ChevronIcon className={styles.expandField} onClick={() => {
                                                                                        const newFields = [...data.fields];
                                                                                        newFields[index] = { ...newFields[index], expanded: !field.expanded };
                                                                                        updateDataProperty('fields', newFields);
                                                                                    }} />
                                                                                </div>
                                                                            }
                                                                            {field.expanded &&
                                                                                <>
                                                                                    <Select appearance="modern" options={fieldTypeOptions} selected={fieldTypeOptions.find(o => o.value === field?.type) ?? fieldTypeOptions[0]} onSelect={(option) => {
                                                                                        const newFields = [...data.fields];
                                                                                        newFields[index] = { ...newFields[index], type: option.value };
                                                                                        updateDataProperty('fields', newFields);
                                                                                    }} />
                                                                                    <TextInput appearance="modern" type="text" placeholder={"Nome"} label={"Nome"} value={field?.name ? field.name.replace(' ', '').replace('-', '') : ''} onKeyUp={(v) => {
                                                                                        const newFields = [...data.fields];
                                                                                        newFields[index] = { ...newFields[index], name: v };
                                                                                        updateDataProperty('fields', newFields);
                                                                                    }} />

                                                                                    {['text', 'textarea'].includes(field?.type) &&
                                                                                        <>
                                                                                            <TextInput appearance="modern" type="text" placeholder={"Placeholder"} label={"Placeholder"} value={field?.placeholder ?? ''} onKeyUp={(v) => {
                                                                                                const newFields = [...data.fields];
                                                                                                newFields[index] = { ...newFields[index], placeholder: v };
                                                                                                updateDataProperty('fields', newFields);
                                                                                            }} />
                                                                                        </>
                                                                                    }
                                                                                    {field?.type === 'checkbox' &&
                                                                                        <div className={styles.editor} data-mdx-color-target="form-field-label" data-mdx-color-index={index}>
                                                                                            <MDXEditor
                                                                                                key={`form-field-label-${block.id}-${index}-${mdxEditorRefreshNonce}`}
                                                                                                className={styles.markdown}
                                                                                                markdown={typeof field?.label === 'string' ? field.label : ''}
                                                                                                onChange={(md) => {
                                                                                                    const newFields = [...data.fields];
                                                                                                    newFields[index] = { ...newFields[index], label: md };
                                                                                                    updateDataProperty('fields', newFields);
                                                                                                }}
                                                                                                plugins={[
                                                                                                    headingsPlugin(),
                                                                                                    listsPlugin(),
                                                                                                    quotePlugin(),
                                                                                                    thematicBreakPlugin(),
                                                                                                    linkDialogPlugin(),
                                                                                                    diffSourcePlugin(),
                                                                                                    tablePlugin(),
                                                                                                    toolbarPlugin({
                                                                                                        toolbarContents: () => (
                                                                                                            <>
                                                                                                                {' '}
                                                                                                                <UndoRedo />
                                                                                                                <Separator />
                                                                                                                <BoldItalicUnderlineToggles />
                                                                                                                <MdxInlineColorButton onOpen={handleOpenMdxColorDialog} />
                                                                                                                <Separator />
                                                                                                                <ListsToggle />
                                                                                                                <CreateLink />
                                                                                                                {/* <InsertTable /> */}
                                                                                                                <Separator />
                                                                                                                <BlockTypeSelect />
                                                                                                                <DiffSourceToggleWrapper options={["rich-text", "source"]} />
                                                                                                            </>
                                                                                                        )
                                                                                                    })
                                                                                                ]}
                                                                                            />
                                                                                        </div>
                                                                                    }

                                                                                    <div className={styles.toggle}>
                                                                                        <Checkbox size="20px" label="Campo obbligatorio" labelPosition='end' radius="6px" value={field?.required ?? false} style={{ maxHeight: '20px' }}
                                                                                            onChange={(checked) => {
                                                                                                const newFields = [...data.fields];
                                                                                                newFields[index] = { ...newFields[index], required: checked };
                                                                                                updateDataProperty('fields', newFields);
                                                                                            }} />
                                                                                        <DeleteIcon className={styles.deleteFormField} onClick={(e) => {
                                                                                            e.stopPropagation()
                                                                                            const newFields = data.fields.filter((_, i) => i !== index);
                                                                                            updateDataProperty('fields', newFields);
                                                                                        }} />
                                                                                    </div>
                                                                                    <ChevronIcon className={styles.collapseField} onClick={() => {
                                                                                        const newFields = [...data.fields];
                                                                                        newFields[index] = { ...newFields[index], expanded: !field.expanded };
                                                                                        updateDataProperty('fields', newFields);
                                                                                    }} />
                                                                                </>
                                                                            }
                                                                        </div>
                                                                    )
                                                                }} />
                                                            </ReactSortable>
                                                        </div>
                                                    }
                                                    <Button appearance='text' onClick={() => {
                                                        //Aggiungo un campo vuoto ai fields
                                                        const newField = { type: 'text', name: '', placeholder: '', required: false };
                                                        const newFields = data?.fields ? [...data.fields, newField] : [newField];
                                                        updateDataProperty('fields', newFields);
                                                    }}>AGGIUNGI CAMPO</Button>
                                                </div>
                                            </div>
                                        </Collapsable>
                                    </>
                                }
                                {block.type === BlockType.Carousel &&
                                    <Collapsable title='CAROUSEL' appearance='modern' active={true} expanded={true}>
                                        <div className={styles.collapsibleContent}>
                                            <div className={styles.carousel}>
                                                <Select appearance="modern" options={carouselTypeOptions} selected={carouselTypeOptions.find(o => o.value === data?.type) ?? carouselTypeOptions[0]} onSelect={(option) => {
                                                    updateDataProperty('type', option.value);
                                                    updateDataProperty('autoScroll', null);
                                                    updateDataProperty('autoplay', false);
                                                }} />
                                                <div className={styles.selectorsRow}>
                                                    <div className={styles.toggle}>
                                                        <Checkbox size="20px" label="Pagination" labelPosition='end' radius="6px" value={data?.pagination ?? true} style={{ maxHeight: '20px' }}
                                                            onChange={(checked) => {
                                                                updateDataProperty('pagination', checked);
                                                            }} />
                                                    </div>
                                                    <div className={styles.toggle}>
                                                        <Checkbox size="20px" label="Arrows" labelPosition='end' radius="6px" value={data?.arrows ?? true} style={{ maxHeight: '20px' }}
                                                            onChange={(checked) => {
                                                                updateDataProperty('arrows', checked);
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className={styles.selectorsRow}>
                                                    <div className={styles.toggle}>
                                                        <Checkbox size="20px" label="Drag" labelPosition='end' radius="6px" value={data?.drag ?? true} style={{ maxHeight: '20px' }}
                                                            onChange={(checked) => {
                                                                updateDataProperty('drag', checked);
                                                            }} />
                                                    </div>
                                                    <div className={styles.toggle}>
                                                        <Checkbox size="20px" label="Grid" labelPosition='end' radius="6px" value={!!data?.grid} style={{ maxHeight: '20px' }}
                                                            onChange={(checked) => {
                                                                updateDataProperty('grid', checked ? { rows: data?.grid?.rows ?? 1, cols: data?.grid?.cols ?? 1 } : null);
                                                                updateDataProperty('perPage', null);
                                                            }} />
                                                    </div>
                                                </div>
                                                {data?.type === 'loop' &&
                                                    <>
                                                        <div className={styles.toggle}>
                                                            <Checkbox size="20px" label="Autoscroll" labelPosition='end' radius="6px" value={!!data?.autoScroll} style={{ maxHeight: '20px' }}
                                                                onChange={(checked) => {
                                                                    if (checked) {
                                                                        updateDataProperty('autoScroll', { speed: 1 });
                                                                    }
                                                                    else {
                                                                        updateDataProperty('autoScroll', null);
                                                                    }
                                                                }} />
                                                        </div>
                                                        {!!data?.autoScroll &&
                                                            <>
                                                                <div className={styles.selectorsRow}>
                                                                    <div className={styles.toggle}>
                                                                        <Checkbox size="20px" label="Rewind" labelPosition='end' radius="6px" value={data?.autoScroll?.rewind} style={{ maxHeight: '20px' }}
                                                                            onChange={(checked) => {
                                                                                updateDataProperty('autoScroll', { ...data?.autoScroll, rewind: checked });
                                                                            }} />
                                                                    </div>
                                                                    <div className={styles.toggle}>
                                                                        <Checkbox size="20px" label="Pause on hover" labelPosition='end' radius="6px" value={data?.autoScroll?.pauseOnHover} style={{ maxHeight: '20px' }}
                                                                            onChange={(checked) => {
                                                                                updateDataProperty('autoScroll', { ...data?.autoScroll, pauseOnHover: checked });
                                                                            }} />
                                                                    </div>
                                                                </div>
                                                                <TextInput appearance="modern" type={"number"} placeholder={"Autoscroll Speed"} label={"Autoscroll Speed"} value={data?.autoScroll?.speed} onKeyUp={(v) => {
                                                                    updateDataProperty('autoScroll', { ...data?.autoScroll, speed: parseFloat(v) })
                                                                }} />
                                                            </>
                                                        }
                                                    </>
                                                }
                                                {data?.type === 'slide' &&
                                                    <>
                                                        <div className={styles.selectorsRow}>
                                                            <div className={styles.toggle}>
                                                                <Checkbox size="20px" label="Autoplay" labelPosition='end' radius="6px" value={!!data?.autoplay} style={{ maxHeight: '20px' }}
                                                                    onChange={(checked) => {
                                                                        updateDataProperty('autoplay', checked);
                                                                    }} />
                                                            </div>
                                                            {data?.autoplay &&
                                                                <>
                                                                    <div className={styles.toggle}>
                                                                        <Checkbox size="20px" label="Rewind" labelPosition='end' radius="6px" value={data?.rewind} style={{ maxHeight: '20px' }}
                                                                            onChange={(checked) => {
                                                                                updateDataProperty('rewind', checked);
                                                                            }} />
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>
                                                        {data?.autoplay &&
                                                            <TextInput appearance="modern" type={"number"} numberType='float' label={"Interval (s)"} decimals={2} placeholder={"Interval (s)"} value={data?.interval / 1000} onKeyUp={(v) => {
                                                                updateDataProperty('interval', parseInt(v * 1000));
                                                            }} />
                                                        }
                                                    </>
                                                }
                                                {data?.grid &&
                                                    <div className={styles.selectorsRow}>
                                                        <TextInput appearance="modern" type={"number"} placeholder={"Rows"} label="ROWS" value={gridRows} onKeyUp={(v) => {
                                                            // setData({ ...data, grid: { ...data?.grid, rows: parseInt(v) } })

                                                            if (view === 'desktop') {
                                                                updateDataProperty('grid', { ...data?.grid, rows: parseInt(v) });
                                                            }
                                                            else if (view === 'tablet') {
                                                                updateDataProperty('breakpoints', {
                                                                    ...data.breakpoints,
                                                                    ...(data.breakpoints ?? {}),
                                                                    768: {
                                                                        ...(data.breakpoints?.[768] ?? {}),
                                                                        grid: {
                                                                            ...(data.breakpoints?.[768]?.grid ?? {}),
                                                                            rows: parseInt(v)
                                                                        }
                                                                    }
                                                                }
                                                                )
                                                            }
                                                            else if (view === 'mobile') {
                                                                updateDataProperty('breakpoints', {
                                                                    ...data.breakpoints,
                                                                    ...(data.breakpoints ?? {}),
                                                                    540: {
                                                                        ...(data.breakpoints?.[540] ?? {}),
                                                                        grid: {
                                                                            ...(data.breakpoints?.[540]?.grid ?? {}),
                                                                            rows: parseInt(v)
                                                                        }
                                                                    }
                                                                }
                                                                )
                                                            }

                                                        }} />
                                                        <TextInput appearance="modern" type={"number"} placeholder={"Columns"} label="COLUMNS" value={gridColumns} onKeyUp={(v) => {
                                                            if (view === 'desktop') {
                                                                updateDataProperty('grid', { ...data?.grid, cols: parseInt(v) });
                                                            }
                                                            else if (view === 'tablet') {
                                                                updateDataProperty('breakpoints', {
                                                                    ...data.breakpoints,
                                                                    768: {
                                                                        ...(data.breakpoints?.[768] ?? {}),
                                                                        grid: {
                                                                            ...(data.breakpoints?.[768]?.grid ?? {}),
                                                                            cols: parseInt(v)
                                                                        }
                                                                    }
                                                                }
                                                                )
                                                            }
                                                            else if (view === 'mobile') {
                                                                updateDataProperty('breakpoints', {
                                                                    ...data.breakpoints,
                                                                    540: {
                                                                        ...(data.breakpoints?.[540] ?? {}),
                                                                        grid: {
                                                                            ...(data.breakpoints?.[540]?.grid ?? {}),
                                                                            cols: parseInt(v)
                                                                        }
                                                                    }
                                                                }
                                                                )
                                                            }
                                                        }} />
                                                    </div>
                                                }
                                                {!data?.grid &&
                                                    <>
                                                        <TextInput appearance="modern" type={"number"} placeholder={"Per Page"} label="PER PAGE" value={perPage} onKeyUp={(v) => {
                                                            if (view === 'desktop') {
                                                                updateDataProperty('perPage', parseInt(v));
                                                            }
                                                            else if (view === 'tablet') {
                                                                updateDataProperty('breakpoints', {
                                                                    ...data.breakpoints,
                                                                    768: {
                                                                        ...(data.breakpoints?.[768] ?? {}),
                                                                        perPage: parseInt(v)
                                                                    }
                                                                }
                                                                )
                                                            }
                                                            else if (view === 'mobile') {
                                                                updateDataProperty('breakpoints', {
                                                                    ...data.breakpoints,
                                                                    540: {
                                                                        ...(data.breakpoints?.[540] ?? {}),
                                                                        perPage: parseInt(v)
                                                                    }
                                                                }
                                                                )
                                                            }
                                                        }} />
                                                    </>
                                                }
                                                <TextInput appearance="modern" type={"number"} placeholder={"Per Move"} label="PER MOVE" value={perMove} onKeyUp={(v) => {
                                                    if (v !== 0) {
                                                        if (view === 'desktop') {
                                                            updateDataProperty('perMove', parseInt(v))
                                                        }
                                                        else if (view === 'tablet') {
                                                            updateDataProperty('breakpoints', {
                                                                ...data.breakpoints,
                                                                768: {
                                                                    ...(data.breakpoints?.[768] ?? {}),
                                                                    perMove: parseInt(v)
                                                                }
                                                            }
                                                            )
                                                        }
                                                        else if (view === 'mobile') {
                                                            updateDataProperty('breakpoints', {
                                                                ...data.breakpoints,
                                                                540: {
                                                                    ...(data.breakpoints?.[540] ?? {}),
                                                                    perMove: parseInt(v)
                                                                }
                                                            }
                                                            )
                                                        }
                                                    }
                                                }} />

                                            </div>
                                        </div>
                                    </Collapsable>
                                }
                                {block.type === BlockType.Editions &&
                                    <div className={styles.editions}>
                                        <Select appearance="modern" placeholder={"Seleziona Corso"} options={courses} selected={courses.find(c => c.id === block?.data?.course_id)} onSelect={(item) => {
                                            updateDataProperty('course_id', item.value)
                                        }} />
                                        <ColorPicker
                                            className={styles.colorPicker}
                                            disableDarkMode
                                            width={350}
                                            height={100}
                                            hidePresets
                                            hideAdvancedSliders
                                            hideColorGuide
                                            hideInputType
                                            hideColorTypeBtns
                                            value={data?.accentColor}
                                            onChange={(color) => {
                                                updateDataProperty('accentColor', color)
                                            }} />
                                        <div className={styles.themeColors}>
                                            <Each of={themeColors} render={(color, index) => {
                                                return (
                                                    <TooltipWrapper text={`${color.hex}`}>
                                                        <div onClick={() => {
                                                            updateDataProperty('accentColor', color.value)
                                                        }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                    </TooltipWrapper>
                                                )
                                            }} />
                                        </div>
                                        {renderUsedPageColors((colorValue) => {
                                            updateDataProperty('accentColor', colorValue)
                                        })}
                                    </div>
                                }
                                {block.type === BlockType.Icon &&
                                    <Collapsable title='ICON' appearance='modern' active={true} expanded={true}>
                                        <div className={styles.icon}>
                                            {data?.icon &&
                                                <div className={styles.iconSVG}
                                                    dangerouslySetInnerHTML={{ __html: data.icon.data.replace("currentColor", viewStyle.color) }}
                                                    onClick={() => { setIconsDialogOpen(true) }}
                                                />
                                            }{
                                                !data?.icon &&
                                                <div className={styles.noIcon} onClick={() => { setIconsDialogOpen(true) }}></div>
                                            }
                                            <ColorPicker
                                                className={styles.colorPicker}
                                                disableDarkMode
                                                width={350}
                                                height={100}
                                                hidePresets
                                                hideAdvancedSliders
                                                hideColorGuide
                                                hideInputType
                                                hideColorTypeBtns
                                                value={viewStyle.color}
                                                onChange={(color) => {
                                                    updateStyleProperty('color', color)
                                                }} />
                                            <div className={styles.themeColors}>
                                                <Each of={themeColors} render={(color, index) => {
                                                    return (
                                                        <TooltipWrapper text={`${color.hex}`}>
                                                            <div onClick={() => {
                                                                updateStyleProperty('color', color.value)
                                                            }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                        </TooltipWrapper>
                                                    )
                                                }} />
                                            </div>
                                            {renderUsedPageColors((colorValue) => {
                                                updateStyleProperty('color', colorValue)
                                            })}
                                        </div>
                                        <div className={styles.actions}>
                                            <div className={styles.actionButton} onClick={() => {
                                                updateStyleProperty('color', null)
                                            }}>
                                                <ResetIcon className={styles.actionIcon} />
                                                <span>RESET</span>
                                            </div>
                                            <div className={styles.actionButton} onClick={() => {
                                                applyToAllViews(['color'])
                                            }}>
                                                <ApplyAllIcon className={styles.actionIcon} />
                                                <span>APPLY TO ALL</span>
                                            </div>
                                        </div>
                                    </Collapsable>
                                }
                                {block.type === BlockType.Faq &&
                                    <Collapsable title='FAQ' appearance='modern' active={true} expanded={true}>
                                        <div className={styles.collapsibleContent}>
                                            <div className={styles.text}>
                                                <TextInput appearance="modern" type={"text"} placeholder={"Titolo"} value={data?.title} onKeyUp={(v) => {
                                                    updateDataProperty('title', v);
                                                }} />

                                                <div className={styles.editor} data-mdx-color-target="faq-description">
                                                    <MDXEditor
                                                        key={`faq-description-${block.id}-${mdxEditorRefreshNonce}`}
                                                        placeholder="contenuto"
                                                        className={styles.markdown}
                                                        markdown={typeof block.data?.description === 'string' ? block.data.description : ''}
                                                        onChange={(md) => {
                                                            updateDataProperty('description', md);
                                                        }}
                                                        plugins={[
                                                            headingsPlugin(),
                                                            listsPlugin(),
                                                            quotePlugin(),
                                                            thematicBreakPlugin(),
                                                            linkDialogPlugin(),
                                                            diffSourcePlugin(),
                                                            tablePlugin(),
                                                            toolbarPlugin({
                                                                toolbarContents: () => (
                                                                    <>
                                                                        {' '}
                                                                        <UndoRedo />
                                                                        <Separator />
                                                                        <BoldItalicUnderlineToggles />
                                                                        <MdxInlineColorButton onOpen={handleOpenMdxColorDialog} />
                                                                        <Separator />
                                                                        <ListsToggle />
                                                                        <CreateLink />
                                                                        {/* <InsertTable /> */}
                                                                        <Separator />
                                                                        <BlockTypeSelect />
                                                                        <DiffSourceToggleWrapper options={["rich-text", "source"]} />
                                                                    </>
                                                                )
                                                            })
                                                        ]}
                                                    />
                                                </div>
                                                <UnitSelector value={data?.textStyle?.fontSize}
                                                    label={"SIZE"}
                                                    onChange={(v) => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, fontSize: v })
                                                    }} />
                                                <UnitSelector value={data?.textStyle?.lineHeight}
                                                    label={"LINE HEIGHT"}
                                                    onChange={(v) => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, lineHeight: v })
                                                    }} />
                                                <Select appearance="modern" options={fontOptions} selected={fontOptions.find(o => o.value === data?.textStyle?.fontFamily) ?? fontOptions[0]} onSelect={(option) => {
                                                    updateDataProperty('textStyle', { ...data?.textStyle, fontFamily: option.value })
                                                }} />
                                                <Select appearance="modern" options={fontWeightOptions} selected={fontWeightOptions.find(o => o.value === data?.textStyle?.fontWeight) ?? fontWeightOptions[2]} onSelect={(option) => {
                                                    updateDataProperty('textStyle', { ...data?.textStyle, fontWeight: option.value })
                                                }} />
                                                <div className={typo.caption}>ALIGNMENT</div>
                                                <div className={styles.alignments}>
                                                    <TextAlignLeft className={`${styles.alignIcon} ${data?.textStyle?.textAlign === 'left' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textAlign: 'left' })
                                                    }} />
                                                    <TextAlignRight className={`${styles.alignIcon} ${data?.textStyle?.textAlign === 'right' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textAlign: 'right' })
                                                    }} />
                                                    <TextAlignCenter className={`${styles.alignIcon} ${data?.textStyle?.textAlign === 'center' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textAlign: 'center' })
                                                    }} />
                                                    <TextAlignJustify className={`${styles.alignIcon} ${data?.textStyle?.textAlign === 'justify' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textAlign: 'justify' })
                                                    }} />
                                                </div>
                                                <div className={typo.caption}>STYLE</div>
                                                <div className={styles.alignments}>
                                                    <TextItalic className={`${styles.alignIcon} ${data?.textStyle?.fontStyle === 'italic' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, fontStyle: data?.textStyle?.fontStyle === 'italic' ? 'normal' : 'italic' })
                                                    }} />
                                                    <TextUppercase className={`${styles.alignIcon} ${data?.textStyle?.textTransform === 'uppercase' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textTransform: data?.textStyle?.textTransform === 'uppercase' ? '' : 'uppercase' })
                                                    }} />
                                                    <TextLowercase className={`${styles.alignIcon} ${data?.textStyle?.textTransform === 'lowercase' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textTransform: data?.textStyle?.textTransform === 'lowercase' ? '' : 'lowercase' })
                                                    }} />
                                                    <TextCapitalize className={`${styles.alignIcon} ${data?.textStyle?.textTransform === 'capitalize' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textTransform: data?.textStyle?.textTransform === 'capitalize' ? '' : 'capitalize' })
                                                    }} />
                                                    <TextUnderline className={`${styles.alignIcon} ${data?.textStyle?.textDecoration === 'underline' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textDecoration: data?.textStyle?.textDecoration === 'underline' ? '' : 'underline' })
                                                    }} />
                                                    <TextOverline className={`${styles.alignIcon} ${data?.textStyle?.textDecoration === 'overline' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textDecoration: data?.textStyle?.textDecoration === 'overline' ? '' : 'overline' })
                                                    }} />
                                                    <TextLinethrough className={`${styles.alignIcon} ${data?.textStyle?.textDecoration === 'line-through' ? styles.selected : ''}`} onClick={() => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, textDecoration: data?.textStyle?.textDecoration === 'line-through' ? '' : 'line-through' })
                                                    }} />
                                                </div>
                                                <div className={typo.caption}>TEXT COLOR</div>
                                                <ColorPicker className={styles.cp} disableDarkMode width={350}
                                                    height={100}
                                                    hidePresets hideColorTypeBtns hideAdvancedSliders hideColorGuide hideInputType value={data?.textStyle?.color ?? '#000000'} onChange={(color) => {
                                                        updateDataProperty('textStyle', { ...data?.textStyle, color: color })
                                                    }} />
                                                <div className={styles.themeColors}>
                                                    <Each of={themeColors} render={(color, index) => {
                                                        return (
                                                            <TooltipWrapper text={`${color.hex}`}>
                                                                <div onClick={() => {
                                                                    updateDataProperty('textStyle', { ...data?.textStyle, color: color.value })
                                                                }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                            </TooltipWrapper>
                                                        )
                                                    }} />
                                                </div>
                                                {renderUsedPageColors((colorValue) => {
                                                    updateDataProperty('textStyle', { ...data?.textStyle, color: colorValue })
                                                })}
                                                <div className={typo.caption} style={{ marginTop: '1rem' }}>BUTTON COLOR</div>
                                                <ColorPicker className={styles.cp} disableDarkMode width={350} height={100} hidePresets hideAdvancedSliders hideColorGuide hideColorTypeBtns hideInputType value={data?.accentColor ?? '#000000'} onChange={(color) => {
                                                    updateDataProperty('accentColor', color)
                                                }} />
                                                <div className={styles.themeColors}>
                                                    <Each of={themeColors} render={(color, index) => {
                                                        return (
                                                            <TooltipWrapper text={`${color.hex}`}>
                                                                <div onClick={() => {
                                                                    updateDataProperty('accentColor', color.value)
                                                                }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                            </TooltipWrapper>
                                                        )
                                                    }} />
                                                </div>
                                                {renderUsedPageColors((colorValue) => {
                                                    updateDataProperty('accentColor', colorValue)
                                                })}
                                            </div>
                                        </div>
                                    </Collapsable>
                                }
                                <Collapsable title="DIMENSIONS" appearance='modern' active={hasNonEmptyString(viewStyle.width, viewStyle.height, viewStyle.maxWidth, viewStyle.maxHeight, viewStyle.minWidth, viewStyle.minHeight)}>
                                    <div className={styles.paddingsInner}>
                                        <UnitSelector value={viewStyle.width}
                                            label={"Width"}
                                            onChange={(v) => {
                                                updateStyleProperty('width', v)
                                            }} />
                                        <UnitSelector value={viewStyle.height}
                                            label={"Height"}
                                            onChange={(v) => {
                                                updateStyleProperty('height', v)
                                            }} />
                                        <UnitSelector value={viewStyle.maxWidth}
                                            label={"Max W"}
                                            onChange={(v) => {
                                                updateStyleProperty('maxWidth', v)
                                            }} />
                                        <UnitSelector value={viewStyle.maxHeight}
                                            label={"Max H"}
                                            onChange={(v) => {
                                                updateStyleProperty('maxHeight', v)
                                            }} />
                                        <UnitSelector value={viewStyle.minWidth}
                                            label={"Min W"}
                                            onChange={(v) => {
                                                updateStyleProperty('minWidth', v)
                                            }} />
                                        <UnitSelector value={viewStyle.minHeight}
                                            label={"Min H"}
                                            onChange={(v) => {
                                                updateStyleProperty('minHeight', v)
                                            }} />
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty(['width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight'], null);
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='ASPECT RATIO' appearance='modern' active={hasNonEmptyString(viewStyle.aspectRatio) && viewStyle.aspectRatio !== 'auto'}>
                                    <div className={styles.collapsibleContent}>
                                        <Select appearance="modern"
                                            options={aspectRatioPresetOptions}
                                            selected={selectedAspectRatioOption}
                                            onSelect={(option) => {
                                                if (!option || option.value === '__custom__') {
                                                    return;
                                                }
                                                updateStyleProperty('aspectRatio', option.value);
                                            }}
                                        />
                                        <div className={styles.selectorsRow}>
                                            <TextInput appearance="modern"
                                                type="number"
                                                numberType='float'
                                                placeholder="W"
                                                label="CUSTOM W"
                                                value={customAspectRatioWidth}
                                                onKeyUp={(value) => {
                                                    const nextValue = typeof value === 'string' ? value : String(value ?? '');
                                                    setCustomAspectRatioWidth(nextValue);
                                                    applyCustomAspectRatio(nextValue, customAspectRatioHeight);
                                                }}
                                            />
                                            <TextInput appearance="modern"
                                                type="number"
                                                numberType='float'
                                                placeholder="H"
                                                label="CUSTOM H"
                                                value={customAspectRatioHeight}
                                                onKeyUp={(value) => {
                                                    const nextValue = typeof value === 'string' ? value : String(value ?? '');
                                                    setCustomAspectRatioHeight(nextValue);
                                                    applyCustomAspectRatio(customAspectRatioWidth, nextValue);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty('aspectRatio', null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['aspectRatio'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title="ALIGN CONTENT" appearance='modern' active={hasNonEmptyString(viewStyle.alignItems, viewStyle.justifyContent)}>
                                    <div className={styles.collapsibleContent}>
                                        <div className={styles.alignmentsSection}>
                                            <div className={styles.alignmentsSectionRow}>
                                                <div className={typo.caption}>VERTICAL</div>
                                                <div className={styles.alignments}>
                                                    {![BlockType.Column, BlockType.Section].includes(block.type) &&
                                                        <>
                                                            <AlignTop className={`${styles.alignIcon} ${viewStyle.alignItems === 'flex-start' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('alignItems', 'flex-start')
                                                            }} />
                                                            <AlignBottom className={`${styles.alignIcon} ${viewStyle.alignItems === 'flex-end' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('alignItems', 'flex-end')
                                                            }} />
                                                            <AlignCenterHorizontal className={`${styles.alignIcon} ${viewStyle.alignItems === 'center' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('alignItems', 'center')
                                                            }} />
                                                        </>
                                                    }
                                                    {[BlockType.Column, BlockType.Section].includes(block.type) &&
                                                        <>
                                                            <AlignTop className={`${styles.alignIcon} ${viewStyle.justifyContent === 'flex-start' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'flex-start')
                                                            }} />
                                                            <AlignBottom className={`${styles.alignIcon} ${viewStyle.justifyContent === 'flex-end' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'flex-end')
                                                            }} />
                                                            <AlignCenterHorizontal className={`${styles.alignIcon} ${viewStyle.justifyContent === 'center' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'center')
                                                            }} />
                                                            <SpaceAround className={`${styles.alignIcon} ${viewStyle.justifyContent === 'space-around' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'space-around')
                                                            }} />
                                                            <SpaceBetween className={`${styles.alignIcon} ${viewStyle.justifyContent === 'space-between' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'space-between')
                                                            }} />
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.alignmentsSectionRow}>
                                                <div className={typo.caption}>HORIZONTAL</div>
                                                <div className={styles.alignments}>
                                                    {![BlockType.Column, BlockType.Section].includes(block.type) &&
                                                        <>
                                                            <AlignLeft className={`${styles.alignIcon} ${viewStyle.justifyContent === 'flex-start' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'flex-start')
                                                            }} />
                                                            <AlignRight className={`${styles.alignIcon} ${viewStyle.justifyContent === 'flex-end' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'flex-end')
                                                            }} />
                                                            <AlignCenterVertical className={`${styles.alignIcon} ${viewStyle.justifyContent === 'center' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'center')
                                                            }} />
                                                            <SpaceAround className={`${styles.alignIcon} ${viewStyle.justifyContent === 'space-around' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'space-around')
                                                            }} />
                                                            <SpaceBetween className={`${styles.alignIcon} ${viewStyle.justifyContent === 'space-between' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('justifyContent', 'space-between')
                                                            }} />
                                                        </>
                                                    }
                                                    {[BlockType.Column, BlockType.Section].includes(block.type) &&
                                                        <>
                                                            <AlignLeft className={`${styles.alignIcon} ${viewStyle.alignItems === 'flex-start' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('alignItems', 'flex-start')
                                                            }} />
                                                            <AlignRight className={`${styles.alignIcon} ${viewStyle.alignItems === 'flex-end' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('alignItems', 'flex-end')
                                                            }} />
                                                            <AlignCenterVertical className={`${styles.alignIcon} ${viewStyle.alignItems === 'center' ? styles.selected : ''}`} onClick={() => {
                                                                updateStyleProperty('alignItems', 'center')
                                                            }} />
                                                        </>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty(['alignItems', 'justifyContent'], null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['alignItems', 'justifyContent'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title="POSITION" appearance='modern' active={hasNonEmptyString(viewStyle.top, viewStyle.right, viewStyle.left, viewStyle.bottom)}>
                                    <div className={styles.collapsibleContent}>
                                        <Select appearance="modern" options={positionOptions} selected={positionOptions.find(o => o.value === viewStyle.position)} nullable label='Position' onSelect={(option) => {
                                            updateStyleProperty('position', option.value)
                                        }} />
                                        <div className={styles.paddingsInner}>
                                            <UnitSelector value={viewStyle.top}
                                                label={"Top"}
                                                onChange={(v) => {
                                                    updateStyleProperty('top', v)
                                                }} />
                                            <UnitSelector value={viewStyle.right}
                                                label={"Right"}
                                                onChange={(v) => {
                                                    updateStyleProperty('right', v)
                                                }} />
                                            <UnitSelector value={viewStyle.left}
                                                label={"Left"}
                                                onChange={(v) => {
                                                    updateStyleProperty('left', v)
                                                }} />
                                            <UnitSelector value={viewStyle.bottom}
                                                label={"Bottom"}
                                                onChange={(v) => {
                                                    updateStyleProperty('bottom', v)
                                                }} />
                                        </div>
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty(['top', 'right', 'left', 'bottom'], null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['top', 'right', 'left', 'bottom'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='BACKGROUND' appearance='modern' active={hasNonEmptyString(viewStyle.backgroundColor, viewStyle.backgroundImage)}>
                                    <div className={styles.collapsibleContent}>
                                        <div className={styles.toggle}>
                                            <Checkbox size="20px" label="Immagine" labelPosition='end' radius="6px" value={!!imageBackground} style={{ maxHeight: '20px' }}
                                                onChange={(checked) => {
                                                    setImageBackground(checked)
                                                }} />
                                        </div>
                                        {imageBackground &&
                                            <div className={styles.backgroundSettings}>
                                                <TextInput appearance="modern" type="text" placeholder={"url"} value={viewStyle.backgroundImage === 'unset' ? '' : backgroundImageToUrl(viewStyle.backgroundImage)} onKeyUp={(v) => {
                                                    updateStyleProperty('backgroundImage', `url("${v}")`)
                                                }} />
                                                <div className={styles.uploader}>
                                                    <Uploader
                                                        preview={viewStyle?.backgroundImage ? backgroundImageToUrl(viewStyle.backgroundImage) : null}
                                                        multiple={false}
                                                        iconButtons={true}
                                                        type={FileType.Image}
                                                        onComplete={(uploads) => {
                                                            updateStyleProperty('backgroundImage', `url("${uploads[0].url}")`)
                                                        }}
                                                        onDelete={() => {
                                                            updateStyleProperty('backgroundImage', null)
                                                        }}
                                                    />
                                                </div>
                                                <div className={typo.caption}>SIZE</div>
                                                <Select appearance="modern" options={backgroundSizeOptions} selected={backgroundSizeOptions.find(o => o.value === viewStyle.backgroundSize) ?? backgroundSizeOptions[0]} onSelect={(option) => {
                                                    updateStyleProperty('backgroundSize', option.value)
                                                }} />
                                                <div className={typo.caption}>POSITION</div>
                                                <Select appearance="modern" options={backgroundPositionOptions} selected={backgroundPositionOptions.find(o => o.value === viewStyle.backgroundPosition) ?? backgroundPositionOptions[0]} onSelect={(option) => {
                                                    updateStyleProperty('backgroundPosition', option.value)
                                                }} />
                                                <div className={typo.caption}>REPEAT</div>
                                                <Select appearance="modern" options={backgroundRepeatOptions} selected={backgroundRepeatOptions.find(o => o.value === viewStyle.backgroundRepeat) ?? backgroundRepeatOptions[0]} onSelect={(option) => {
                                                    updateStyleProperty('backgroundRepeat', option.value)
                                                }} />
                                                <div className={styles.actions}>
                                                    <div className={styles.actionButton} onClick={() => {
                                                        updateStyleProperty(['backgroundImage', 'backgroundSize', 'backgroundPosition', 'backgroundRepeat'], null)
                                                    }}>
                                                        <ResetIcon className={styles.actionIcon} />
                                                        <span>RESET</span>
                                                    </div>
                                                    <div className={styles.actionButton} onClick={() => {
                                                        applyToAllViews(['backgroundImage', 'backgroundSize', 'backgroundPosition', 'backgroundRepeat'])
                                                    }}>
                                                        <ApplyAllIcon className={styles.actionIcon} />
                                                        <span>APPLY TO ALL</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <div className={styles.toggle}>
                                            <Checkbox size="20px" label="Colore" labelPosition='end' radius="6px" value={!!colorBackground} style={{ maxHeight: '20px' }}
                                                onChange={(checked) => {
                                                    setColorBackground(checked)
                                                    if (['linear-gradient', 'radial-gradient', 'repeating-linear-gradient', 'repeating-radial-gradient'].some(gradientType => viewStyle.backgroundImage?.startsWith(gradientType))) {
                                                        updateStyleProperty(['backgroundImage', 'backgroundSize', 'backgroundPosition', 'backgroundRepeat', 'backgroundColor'], null)
                                                    }
                                                    else {
                                                        updateStyleProperty('backgroundColor', checked ? 'rgba(0,0,0,0)' : null)
                                                    }
                                                }} />
                                        </div>
                                        {colorBackground &&
                                            <>
                                                <ColorPicker
                                                    className={styles.colorPicker}
                                                    disableDarkMode
                                                    width={350}
                                                    height={100}
                                                    hidePresets
                                                    hideAdvancedSliders
                                                    hideColorGuide
                                                    hideInputType
                                                    value={viewStyle.backgroundImage?.startsWith('linear-gradient') ? viewStyle.backgroundImage : viewStyle.backgroundColor ?? 'rgba(0,0,0,0)'}
                                                    onChange={(color) => {
                                                        if (['linear-gradient', 'radial-gradient'].some(gradientType => color.startsWith(gradientType))) {
                                                            updateStyleProperty('backgroundImage', color)
                                                        }
                                                        else {
                                                            updateStyleProperty({ backgroundColor: color, backgroundImage: null })
                                                        }
                                                    }} />
                                                <div className={styles.themeColors}>
                                                    <Each of={themeColors} render={(color, index) => {
                                                        return (
                                                            <TooltipWrapper text={`${color.hex}`}>
                                                                <div onClick={() => {
                                                                    updateStyleProperty({ backgroundColor: color.value, backgroundImage: null })
                                                                }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                            </TooltipWrapper>
                                                        )
                                                    }} />
                                                </div>
                                                {renderUsedPageColors((colorValue) => {
                                                    updateStyleProperty({ backgroundColor: colorValue, backgroundImage: null })
                                                })}

                                                <div className={styles.actions}>
                                                    <div className={styles.actionButton} onClick={() => {
                                                        if (['linear-gradient', 'radial-gradient', 'repeating-linear-gradient', 'repeating-radial-gradient'].some(gradientType => viewStyle.backgroundImage?.startsWith(gradientType))) {
                                                            updateStyleProperty(['backgroundColor', 'backgroundImage'], null)
                                                        }
                                                        else {
                                                            updateStyleProperty('backgroundColor', null)
                                                        }
                                                    }}>
                                                        <ResetIcon className={styles.actionIcon} />
                                                        <span>RESET</span>
                                                    </div>
                                                    <div className={styles.actionButton} onClick={() => {
                                                        let props = ['backgroundColor']
                                                        if (['linear-gradient', 'radial-gradient', 'repeating-linear-gradient', 'repeating-radial-gradient'].some(gradientType => viewStyle.backgroundImage?.startsWith(gradientType))) {
                                                            props.push('backgroundImage')
                                                        }
                                                        applyToAllViews(props)
                                                    }}>
                                                        <ApplyAllIcon className={styles.actionIcon} />
                                                        <span>APPLY TO ALL</span>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </Collapsable>
                                <Collapsable title='PADDING' appearance='modern' active={hasNonEmptyString(viewStyle.paddingTop, viewStyle.paddingRight, viewStyle.paddingLeft, viewStyle.paddingBottom)}>
                                    <div className={styles.collapsibleContent}>
                                        <UnitSelector value={(viewStyle.paddingTop === viewStyle.paddingRight && viewStyle.paddingTop === viewStyle.paddingLeft && viewStyle.paddingTop === viewStyle.paddingBottom) ? viewStyle.paddingTop : null}
                                            label={"ALL"}
                                            onChange={(value) => {
                                                if (hasNonEmptyString(value)) {
                                                    updateStyleProperty(['paddingRight', 'paddingLeft', 'paddingTop', 'paddingBottom'], value)
                                                }
                                            }} />

                                        <div className={styles.paddingsInner}>
                                            <UnitSelector value={viewStyle.paddingTop}
                                                label={"TOP"}
                                                onChange={(v) => {
                                                    updateStyleProperty('paddingTop', v)
                                                }} />
                                            <UnitSelector value={viewStyle.paddingRight}
                                                label={"RIGHT"}
                                                onChange={(v) => {
                                                    updateStyleProperty('paddingRight', v)
                                                }} />
                                            <UnitSelector value={viewStyle.paddingLeft}
                                                label={"LEFT"}
                                                onChange={(v) => {
                                                    updateStyleProperty('paddingLeft', v)
                                                }} />
                                            <UnitSelector value={viewStyle.paddingBottom}
                                                label={"BOTTOM"}
                                                onChange={(v) => {
                                                    updateStyleProperty('paddingBottom', v)
                                                }} />
                                        </div>
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty(['paddingRight', 'paddingLeft', 'paddingTop', 'paddingBottom'], null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['paddingTop', 'paddingRight', 'paddingLeft', 'paddingBottom'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='MARGIN' appearance='modern' active={hasNonEmptyString(viewStyle.marginTop, viewStyle.marginRight, viewStyle.marginLeft, viewStyle.marginBottom)}>
                                    <div className={styles.collapsibleContent}>
                                        <UnitSelector value={(viewStyle.marginTop === viewStyle.marginRight && viewStyle.marginTop === viewStyle.marginLeft && viewStyle.marginTop === viewStyle.marginBottom) ? viewStyle.marginTop : null}
                                            label={"ALL"}
                                            onChange={(value) => {
                                                if (hasNonEmptyString(value)) {
                                                    updateStyleProperty(['marginTop', 'marginRight', 'marginLeft', 'marginBottom'], value)
                                                }
                                            }} />

                                        <div className={styles.paddingsInner}>
                                            <UnitSelector value={viewStyle.marginTop}
                                                label={"TOP"}
                                                onChange={(v) => {
                                                    updateStyleProperty('marginTop', v)
                                                }} />
                                            <UnitSelector value={viewStyle.marginRight}
                                                label={"RIGHT"}
                                                onChange={(v) => {
                                                    updateStyleProperty('marginRight', v)
                                                }} />
                                            <UnitSelector value={viewStyle.marginLeft}
                                                label={"LEFT"}
                                                onChange={(v) => {
                                                    updateStyleProperty('marginLeft', v)
                                                }} />
                                            <UnitSelector value={viewStyle.marginBottom}
                                                label={"BOTTOM"}
                                                onChange={(v) => {
                                                    updateStyleProperty('marginBottom', v)
                                                }} />
                                        </div>
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty(['marginTop', 'marginRight', 'marginLeft', 'marginBottom'], null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['marginTop', 'marginRight', 'marginBottom', 'marginLeft'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='BORDERS' appearance='modern' active={hasNonEmptyString(viewStyle.borderTop, viewStyle.borderRight, viewStyle.borderBottom, viewStyle.borderLeft)}>
                                    <div className={styles.collapsibleContent}>
                                        <div className={styles.selectorsRow}>
                                            <BorderAll />
                                            <UnitSelector value={parseBorder(viewStyle.borderTop)?.width === parseBorder(viewStyle.borderRight)?.width && parseBorder(viewStyle.borderTop)?.width === parseBorder(viewStyle.borderBottom)?.width && parseBorder(viewStyle.borderTop)?.width === parseBorder(viewStyle.borderLeft)?.width ? parseBorder(viewStyle.borderTop)?.width : null}
                                                label={"ALL"}
                                                onChange={(v) => {
                                                    let value = v
                                                    let parsedTop = parseBorder(viewStyle.borderTop)
                                                    let parsedRight = parseBorder(viewStyle.borderRight)
                                                    let parsedBottom = parseBorder(viewStyle.borderBottom)
                                                    let parsedLeft = parseBorder(viewStyle.borderLeft)
                                                    if (!v) {
                                                        value = ''
                                                        return;
                                                    }

                                                    updateStyleProperty({
                                                        borderTop: `${value} ${parsedTop.style ?? 'none'} ${parsedTop.color ?? ''}`,
                                                        borderRight: `${value} ${parsedRight.style ?? 'none'} ${parsedRight.color ?? ''}`,
                                                        borderBottom: `${value} ${parsedBottom.style ?? 'none'} ${parsedBottom.color ?? ''}`,
                                                        borderLeft: `${value} ${parsedLeft.style ?? 'none'} ${parsedLeft.color ?? ''}`,
                                                    })

                                                }} />
                                            <Select appearance="modern" style={{ height: 'fit-content' }} options={borderOptions} selected={borderOptions.find(o => o.value === (parseBorder(viewStyle.borderTop)?.style === parseBorder(viewStyle.borderRight)?.style && parseBorder(viewStyle.borderTop)?.style === parseBorder(viewStyle.borderBottom)?.style && parseBorder(viewStyle.borderTop)?.style === parseBorder(viewStyle.borderLeft)?.style ? parseBorder(viewStyle.borderTop)?.style : null)) ?? borderOptions[0]} onSelect={(value) => {
                                                let parsedTop = parseBorder(viewStyle.borderTop)
                                                let parsedRight = parseBorder(viewStyle.borderRight)
                                                let parsedBottom = parseBorder(viewStyle.borderBottom)
                                                let parsedLeft = parseBorder(viewStyle.borderLeft)
                                                updateStyleProperty({
                                                    borderTop: `${parsedTop.width ?? ''} ${value.value} ${parsedTop.color ?? ''}`,
                                                    borderRight: `${parsedRight.width ?? ''} ${value.value} ${parsedRight.color ?? ''}`,
                                                    borderBottom: `${parsedBottom.width ?? ''} ${value.value} ${parsedBottom.color ?? ''}`,
                                                    borderLeft: `${parsedLeft.width ?? ''} ${value.value} ${parsedLeft.color ?? ''}`,
                                                })
                                            }} />
                                        </div>
                                        <Each of={['borderTop', 'borderRight', 'borderBottom', 'borderLeft']} render={(side) => {
                                            let icon = null
                                            switch (side) {
                                                case 'borderTop':
                                                    icon = <BorderTop />
                                                    break;
                                                case 'borderRight':
                                                    icon = <BorderRight />
                                                    break;
                                                case 'borderBottom':
                                                    icon = <BorderBottom />
                                                    break;
                                                case 'borderLeft':
                                                    icon = <BorderLeft />
                                                    break;
                                                default:
                                                    icon = null;
                                            }
                                            return (
                                                <div className={styles.selectorsRow}>
                                                    {icon && icon}
                                                    <UnitSelector value={parseBorder(viewStyle[side])?.width}
                                                        label={side.replace('border', '').toUpperCase()}
                                                        onChange={(v) => {
                                                            let value = v
                                                            let parsed = parseBorder(viewStyle[side])
                                                            if (!v) {
                                                                value = ''
                                                                updateStyleProperty(side, `${value} ${'none'} ${parsed.color ?? ''}`)
                                                                return;
                                                            }
                                                            if (value !== parsed.width) {
                                                                updateStyleProperty(side, `${value} ${parsed.style ?? 'none'} ${parsed.color ?? ''}`)
                                                            }
                                                        }} />
                                                    <Select appearance="modern" style={{ height: 'fit-content' }} options={borderOptions} selected={borderOptions.find(o => o.value === parseBorder(viewStyle[side])?.style) ?? borderOptions[0]} onSelect={(value) => {
                                                        let parsed = parseBorder(viewStyle[side])
                                                        if (value.value !== parsed.style) {
                                                            updateStyleProperty(side, `${parsed.width ?? ''} ${value.value} ${parsed.color ?? ''}`)
                                                        }
                                                    }} />
                                                </div>
                                            )
                                        }} />
                                        <ColorPicker
                                            width={350}
                                            height={100}
                                            className={styles.colorPicker}
                                            disableDarkMode
                                            hidePresets
                                            hideAdvancedSliders
                                            hideColorGuide
                                            hideInputType
                                            hideColorTypeBtns
                                            value={parseBorder(viewStyle.borderTop)?.color || parseBorder(viewStyle.borderRight)?.color || parseBorder(viewStyle.borderBottom)?.color || parseBorder(viewStyle.borderLeft)?.color || ''}
                                            onChange={(color) => {
                                                let parsedTop = parseBorder(viewStyle.borderTop)
                                                let parsedRight = parseBorder(viewStyle.borderRight)
                                                let parsedBottom = parseBorder(viewStyle.borderBottom)
                                                let parsedLeft = parseBorder(viewStyle.borderLeft)

                                                updateStyleProperty({
                                                    borderTop: `${parsedTop.width ?? ''} ${parsedTop.style ?? 'none'} ${color}`,
                                                    borderRight: `${parsedRight.width ?? ''} ${parsedRight.style ?? 'none'} ${color}`,
                                                    borderBottom: `${parsedBottom.width ?? ''} ${parsedBottom.style ?? 'none'} ${color}`,
                                                    borderLeft: `${parsedLeft.width ?? ''} ${parsedLeft.style ?? 'none'} ${color}`,
                                                })
                                            }} />

                                        <div className={styles.themeColors}>
                                            <Each of={themeColors} render={(color, index) => {
                                                return (
                                                    <TooltipWrapper text={`${color.hex}`}>
                                                        <div onClick={() => {
                                                            let parsedTop = parseBorder(viewStyle.borderTop)
                                                            let parsedRight = parseBorder(viewStyle.borderRight)
                                                            let parsedBottom = parseBorder(viewStyle.borderBottom)
                                                            let parsedLeft = parseBorder(viewStyle.borderLeft)

                                                            updateStyleProperty({
                                                                borderTop: `${parsedTop.width ?? ''} ${parsedTop.style ?? 'none'} ${color.value}`,
                                                                borderRight: `${parsedRight.width ?? ''} ${parsedRight.style ?? 'none'} ${color.value}`,
                                                                borderBottom: `${parsedBottom.width ?? ''} ${parsedBottom.style ?? 'none'} ${color.value}`,
                                                                borderLeft: `${parsedLeft.width ?? ''} ${parsedLeft.style ?? 'none'} ${color.value}`,
                                                            })
                                                        }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                    </TooltipWrapper>
                                                )
                                            }} />
                                        </div>
                                        {renderUsedPageColors((colorValue) => {
                                            let parsedTop = parseBorder(viewStyle.borderTop)
                                            let parsedRight = parseBorder(viewStyle.borderRight)
                                            let parsedBottom = parseBorder(viewStyle.borderBottom)
                                            let parsedLeft = parseBorder(viewStyle.borderLeft)

                                            updateStyleProperty({
                                                borderTop: `${parsedTop.width ?? ''} ${parsedTop.style ?? 'none'} ${colorValue}`,
                                                borderRight: `${parsedRight.width ?? ''} ${parsedRight.style ?? 'none'} ${colorValue}`,
                                                borderBottom: `${parsedBottom.width ?? ''} ${parsedBottom.style ?? 'none'} ${colorValue}`,
                                                borderLeft: `${parsedLeft.width ?? ''} ${parsedLeft.style ?? 'none'} ${colorValue}`,
                                            })
                                        })}
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty({
                                                borderTop: null,
                                                borderRight: null,
                                                borderBottom: null,
                                                borderLeft: null
                                            })
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['borderTop', 'borderRight', 'borderBottom', 'borderLeft'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>

                                    </div>
                                </Collapsable>
                                <Collapsable title='BORDER RADIUS' appearance='modern' active={hasNonEmptyString(viewStyle.borderTopLeftRadius, viewStyle.borderTopRightRadius, viewStyle.borderBottomLeftRadius, viewStyle.borderBottomRightRadius)}>
                                    <div className={styles.collapsibleContent}>
                                        <UnitSelector value={(viewStyle.borderTopLeftRadius === viewStyle.borderTopRightRadius && viewStyle.borderTopLeftRadius === viewStyle.borderBottomLeftRadius && viewStyle.borderTopLeftRadius === viewStyle.borderBottomRightRadius) ? viewStyle.borderTopLeftRadius : null}
                                            label={"ALL"}
                                            onChange={(value) => {
                                                if (hasNonEmptyString(value)) {
                                                    updateStyleProperty(['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'], value)
                                                }
                                            }} />

                                        <div className={styles.paddingsInner}>
                                            <UnitSelector value={viewStyle.borderTopLeftRadius}
                                                label={"TOP"}
                                                onChange={(v) => {
                                                    updateStyleProperty('borderTopLeftRadius', v)
                                                }} />
                                            <UnitSelector value={viewStyle.borderTopRightRadius}
                                                label={"RIGHT"}
                                                onChange={(v) => {
                                                    updateStyleProperty('borderTopRightRadius', v)
                                                }} />
                                            <UnitSelector value={viewStyle.borderBottomLeftRadius}
                                                label={"LEFT"}
                                                onChange={(v) => {
                                                    updateStyleProperty('borderBottomLeftRadius', v)
                                                }} />
                                            <UnitSelector value={viewStyle.borderBottomRightRadius}
                                                label={"BOTTOM"}
                                                onChange={(v) => {
                                                    updateStyleProperty('borderBottomRightRadius', v)
                                                }} />
                                        </div>
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty(['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomLeftRadius', 'borderBottomRightRadius', 'borderRadius'], null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomLeftRadius', 'borderBottomRightRadius'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='TRANSFORM' appearance='modern' active={hasNonEmptyString(transform?.translateX, transform?.translateY, transform?.rotate, transform?.scale)}>
                                    <div className={styles.collapsibleContent}>
                                        <div className={styles.paddingsInner}>
                                            <UnitSelector value={transform?.translateX}
                                                label={"TranslateX"}
                                                onChange={(v) => {
                                                    setTransform((prev) => {
                                                        prev.translateX = v
                                                        return { ...prev }
                                                    })
                                                }} />
                                            <UnitSelector value={transform?.translateY}
                                                label={"TranslateY"}
                                                onChange={(v) => {
                                                    setTransform((prev) => {
                                                        prev.translateY = v
                                                        return { ...prev }
                                                    })
                                                }} />
                                            <UnitSelector value={transform?.rotate}
                                                label={"Rotate"}
                                                defaultUnit={"deg"}
                                                disableUnit={true}
                                                onChange={(v) => {
                                                    setTransform((prev) => {
                                                        prev.rotate = v
                                                        return { ...prev }
                                                    })
                                                }} />
                                            <TextInput appearance="modern" type="number" numberType='float' placeholder={"Scale"} value={transform?.scale} onKeyUp={(v) => {
                                                setTransform((prev) => {
                                                    prev.scale = parseFloat(v)
                                                    return { ...prev }
                                                })
                                            }} />
                                        </div>
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            setTransform({ translateX: null, translateY: null, rotate: null, scale: null })
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['transform'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='SHADOW' appearance='modern' active={hasNonEmptyString(boxShadow?.vOffset, boxShadow?.hOffset, boxShadow?.blur, boxShadow?.spread, boxShadow?.color)}>
                                    <div className={styles.collapsibleContent} style={{ gap: '1rem' }}>
                                        <ColorPicker
                                            width={350}
                                            height={100}
                                            className={styles.colorPicker}
                                            disableDarkMode
                                            hidePresets
                                            hideAdvancedSliders
                                            hideColorGuide
                                            hideInputType
                                            hideColorTypeBtns
                                            value={boxShadow?.color}
                                            onChange={(color) => {
                                                setBoxShadow((prev) => {
                                                    prev.color = color
                                                    return { ...prev }
                                                })
                                            }} />

                                        <div className={styles.themeColors}>
                                            <Each of={themeColors} render={(color, index) => {
                                                return (
                                                    <TooltipWrapper text={`${color.hex}`}>
                                                        <div onClick={() => {
                                                            setBoxShadow((prev) => {
                                                                prev.color = color.value
                                                                return { ...prev }
                                                            })
                                                        }} className={styles.color} style={{ backgroundColor: `${color.value}` }}></div>
                                                    </TooltipWrapper>
                                                )
                                            }} />
                                        </div>
                                        {renderUsedPageColors((colorValue) => {
                                            setBoxShadow((prev) => {
                                                prev.color = colorValue
                                                return { ...prev }
                                            })
                                        })}
                                        <div className={styles.paddingsInner}>
                                            <UnitSelector value={(boxShadow?.vOffset)}
                                                label={"V OFFSET"}
                                                onChange={(v) => {
                                                    setBoxShadow((prev) => {
                                                        prev.vOffset = v
                                                        return { ...prev }
                                                    })
                                                }} />
                                            <UnitSelector value={boxShadow?.hOffset}
                                                label={"H OFFSET"}
                                                onChange={(v) => {
                                                    setBoxShadow((prev) => {
                                                        prev.hOffset = v
                                                        return { ...prev }
                                                    })
                                                }} />
                                            <UnitSelector value={boxShadow?.blur}
                                                label={"BLUR"}
                                                onChange={(v) => {
                                                    setBoxShadow((prev) => {
                                                        prev.blur = v
                                                        return { ...prev }
                                                    })
                                                }} />
                                            <UnitSelector value={boxShadow?.spread}
                                                label={"SPREAD"}
                                                onChange={(v) => {
                                                    setBoxShadow((prev) => {
                                                        prev.spread = v
                                                        return { ...prev }
                                                    })
                                                }} />
                                        </div>
                                        <div className={styles.toggle}>
                                            <Checkbox size="20px" label="Inset" labelPosition='end' radius="6px" value={boxShadow?.inset === 'inset'} style={{ maxHeight: '20px' }}
                                                onChange={(checked) => {
                                                    setBoxShadow((prev) => {
                                                        prev.inset = checked ? 'inset' : ''
                                                        return { ...prev }
                                                    })
                                                }} />
                                        </div>
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            setBoxShadow({ vOffset: null, hOffset: null, blur: null, spread: null, color: null, inset: '' })
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['boxShadow'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='GAP' appearance='modern' active={hasNonEmptyString(viewStyle.gap, data?.gap)}>
                                    <div className={styles.collapsibleContent}>
                                        <UnitSelector value={viewStyle.gap}
                                            label={"GAP"}
                                            onChange={(v) => {
                                                if (block.type === BlockType.Carousel) {
                                                    updateDataProperty('gap', v)
                                                }
                                                else {
                                                    updateStyleProperty('gap', v)
                                                }
                                            }} />
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty('gap', null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['gap'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='CURSOR' appearance='modern' active={hasNonEmptyString(viewStyle.cursor) && viewStyle.cursor !== 'default'}>
                                    <div className={styles.collapsibleContent}>
                                        <Select appearance="modern" options={cursorOptions} selected={cursorOptions.find(o => o.value === viewStyle.cursor) ?? (block.type === BlockType.Button ? cursorOptions[1] : cursorOptions[0])} onSelect={(option) => {
                                            updateStyleProperty('cursor', option.value)
                                        }} />
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty('cursor', null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['cursor'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='OVERFLOW' appearance='modern' active={hasNonEmptyString(viewStyle.overflow)}>
                                    <div className={styles.collapsibleContent}>
                                        <Select appearance="modern" options={overflowOptions} selected={overflowOptions.find(o => o.value === viewStyle.overflow) ?? overflowOptions[0]} onSelect={(option) => {
                                            updateStyleProperty('overflow', option.value)
                                        }} />
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty('overflow', null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['overflow'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='Z-INDEX' appearance='modern' active={!isNaN(parseInt(viewStyle.zIndex))}>
                                    <div className={styles.collapsibleContent}>
                                        <TextInput appearance="modern" type="number" placeholder={"z-index"} value={viewStyle.zIndex} onKeyUp={(v) => {
                                            updateStyleProperty('zIndex', v)
                                        }} />
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty('zIndex', null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['zIndex'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>
                                <Collapsable title='VISIBILITY' appearance='modern' active={hasNonEmptyString(viewStyle.opacity) || viewStyle.visibility === "hidden" || viewStyle.display === 'none'}>
                                    <div className={styles.collapsibleContent}>
                                        <div className={styles.toggle}>
                                            <Checkbox size="20px" label="Display" labelPosition='end' radius="6px" value={viewStyle.display !== 'none'} style={{ maxHeight: '20px' }}
                                                onChange={(checked) => {
                                                    updateStyleProperty('display', checked ? 'flex' : 'none')
                                                }} />
                                        </div>
                                        <Select appearance="modern" options={visibilityOptions} selected={visibilityOptions.find(o => o.value === viewStyle.visibility) ?? visibilityOptions[0]} onSelect={(option) => {
                                            updateStyleProperty('visibility', option.value)
                                        }} />
                                        <TextInput appearance="modern" type="number" numberType='float' decimals={2} placeholder={"Opacity"} value={viewStyle.opacity} onKeyUp={(v) => {
                                            updateStyleProperty('opacity', v)
                                        }} />
                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty(['display', 'visibility', 'opacity'], null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['display', 'visibility', 'opacity'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>

                                <Collapsable title='WHITE SPACE' appearance='modern' active={hasNonEmptyString(viewStyle.whiteSpace)}>
                                    <div className={styles.collapsibleContent}>
                                        <Select appearance="modern" options={whiteSpaceOptions} selected={whiteSpaceOptions.find(o => o.value === viewStyle.whiteSpace)} onSelect={(option) => {
                                            updateStyleProperty('whiteSpace', option.value)
                                        }} />

                                    </div>
                                    <div className={styles.actions}>
                                        <div className={styles.actionButton} onClick={() => {
                                            updateStyleProperty('whiteSpace', null)
                                        }}>
                                            <ResetIcon className={styles.actionIcon} />
                                            <span>RESET</span>
                                        </div>
                                        <div className={styles.actionButton} onClick={() => {
                                            applyToAllViews(['whiteSpace'])
                                        }}>
                                            <ApplyAllIcon className={styles.actionIcon} />
                                            <span>APPLY TO ALL</span>
                                        </div>
                                    </div>
                                </Collapsable>

                                <Collapsable title='ACTIONS' appearance='modern' active={data?.actions?.length > 0}>
                                    <div className={styles.collapsibleContent}>
                                        {actionItems.length === 0 && (
                                            <div className={typo.caption}>Nessuna action configurata</div>
                                        )}
                                        <Each of={actionItems} render={(action, index) => {
                                            const propertiesEntries = Object.entries(action?.properties ?? {});
                                            const attributesEntries = Object.entries(action?.attributes ?? {});
                                            const isExpanded = expandedActionIndex === index;
                                            const actionLabel = actionsOptions.find((option) => option.value === action?.type)?.name ?? action?.type ?? 'Action';
                                            const selectedTarget = actionTargetOptions.find((option) => String(option.value) === String(action?.target ?? '')) ?? actionTargetOptions[0];

                                            return (
                                                <div className={styles.actionCard}>
                                                    <div className={styles.actionCardHeader} onClick={() => {
                                                        setExpandedActionIndex((current) => current === index ? null : index);
                                                    }}>
                                                        <div className={styles.actionCardHeaderMain}>
                                                            <DeleteIcon
                                                                className={styles.deleteAction}
                                                                onMouseDown={(event) => {
                                                                    event.preventDefault();
                                                                    event.stopPropagation();
                                                                }}
                                                                onClick={(event) => {
                                                                    event.preventDefault();
                                                                    event.stopPropagation();

                                                                    const ownerId = actionTargetSourceBlockId ?? block?.id ?? selectedBlock?.id;
                                                                    if (!ownerId) {
                                                                        return;
                                                                    }

                                                                    const ownerCandidates = [ownerId, String(ownerId)];
                                                                    const ownerAsNumber = Number(ownerId);
                                                                    if (!Number.isNaN(ownerAsNumber)) {
                                                                        ownerCandidates.push(ownerAsNumber);
                                                                    }

                                                                    let ownerBlock = null;
                                                                    for (const candidate of ownerCandidates) {
                                                                        ownerBlock = findBlockById(candidate);
                                                                        if (ownerBlock) {
                                                                            break;
                                                                        }
                                                                    }

                                                                    const actions = Array.isArray(ownerBlock?.data?.actions)
                                                                        ? [...ownerBlock.data.actions]
                                                                        : Array.isArray(data?.actions)
                                                                            ? [...data.actions]
                                                                            : [];

                                                                    if (index < 0 || index >= actions.length) {
                                                                        return;
                                                                    }

                                                                    actions.splice(index, 1);

                                                                    const nextData = _.isPlainObject(ownerBlock?.data) ? { ...ownerBlock.data } : {};
                                                                    if (actions.length > 0) {
                                                                        nextData.actions = actions;
                                                                    } else {
                                                                        nextData.actions = [];
                                                                    }

                                                                    updateBlock(ownerBlock?.id ?? ownerId, { data: nextData });

                                                                    if (actionTargetSourceBlockId === (ownerBlock?.id ?? ownerId) && actionTargetPickerIndex != null) {
                                                                        if (actionTargetPickerIndex === index) {
                                                                            setActionTargetPickerIndex(null);
                                                                            setActionTargetCandidateId(null);
                                                                            setActionTargetSourceBlockId(null);
                                                                        } else if (actionTargetPickerIndex > index) {
                                                                            setActionTargetPickerIndex((prev) => prev == null ? null : prev - 1);
                                                                        }
                                                                    }

                                                                    setExpandedActionIndex((current) => {
                                                                        if (current == null) {
                                                                            return current;
                                                                        }
                                                                        if (current === index) {
                                                                            return null;
                                                                        }
                                                                        if (current > index) {
                                                                            return current - 1;
                                                                        }
                                                                        return current;
                                                                    });
                                                                }}
                                                            />
                                                            <div className={styles.actionCardMeta}>
                                                                <div className={styles.actionCardTitle}>{actionLabel}</div>
                                                                <div className={styles.actionCardSubtitle}>
                                                                    {describeActionTarget(action?.target)} • {propertiesEntries.length} prop • {attributesEntries.length} attr
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={styles.actionCardTools}>
                                                            <ChevronIcon className={`${styles.actionCardChevron} ${isExpanded ? styles.actionCardChevronOpen : ''}`} />
                                                        </div>
                                                    </div>

                                                    {isExpanded && (
                                                        <div className={styles.actionCardBody}>
                                                            <div className={typo.caption}>TYPE</div>
                                                            <Select appearance="modern" options={actionsOptions} selected={actionsOptions.find((option) => option.value === action?.type) ?? actionsOptions[0]} onSelect={(option) => {
                                                                updateActionItem(index, (item) => ({
                                                                    ...item,
                                                                    type: option.value
                                                                }));
                                                            }} />

                                                            <div className={typo.caption}>TARGET</div>
                                                            <div className={styles.actionTargetRow}>
                                                                <Select appearance="modern" options={actionTargetOptions} selected={selectedTarget} onSelect={(option) => {
                                                                    updateActionItem(index, (item) => ({
                                                                        ...item,
                                                                        target: option.value
                                                                    }));
                                                                }} />
                                                                <button
                                                                    type="button"
                                                                    title="Seleziona target dal builder"
                                                                    className={`${styles.actionTargetIconButton} ${actionTargetPickerIndex === index && actionTargetSourceBlockId === block?.id ? styles.actionTargetIconButtonActive : ''}`}
                                                                    onClick={() => {
                                                                        if (actionTargetPickerIndex === index && actionTargetSourceBlockId === block?.id) {
                                                                            setActionTargetPickerIndex(null);
                                                                            setActionTargetCandidateId(null);
                                                                            setActionTargetSourceBlockId(null);
                                                                            return;
                                                                        }

                                                                        setActionTargetPickerIndex(index);
                                                                        setActionTargetSourceBlockId(block?.id ?? null);
                                                                        setActionTargetCandidateId(selectedBlock?.id ? String(selectedBlock.id) : '');
                                                                    }}
                                                                >
                                                                    <TargetIcon className={styles.actionTargetIcon} />
                                                                </button>
                                                            </div>
                                                            <TextInput appearance="modern" type="text" placeholder={"Target custom (opzionale)"} value={action?.target ?? ''} onKeyUp={(value) => {
                                                                updateActionItem(index, (item) => ({
                                                                    ...item,
                                                                    target: value
                                                                }));
                                                            }} />

                                                            <div className={typo.caption}>PROPERTIES</div>
                                                            <Each of={propertiesEntries} render={([key, value]) => {
                                                                const isCustomProperty = !cssPropertyValueSet.has(key);
                                                                const selectedPropertyOption = isCustomProperty
                                                                    ? cssPropertyOptionsWithCustom[cssPropertyOptionsWithCustom.length - 1]
                                                                    : cssPropertyOptionsWithCustom.find((option) => option.value === key);

                                                                return (
                                                                    <div className={styles.property}>
                                                                        <div className={styles.propertyTopRow}>
                                                                            <DeleteIcon className={styles.deleteProperty} onClick={() => {
                                                                                updateActionItem(index, (item) => {
                                                                                    const nextProperties = { ...(item.properties ?? {}) };
                                                                                    delete nextProperties[key];
                                                                                    return {
                                                                                        ...item,
                                                                                        properties: nextProperties
                                                                                    };
                                                                                });
                                                                            }} />
                                                                            <Select appearance="modern" options={cssPropertyOptionsWithCustom} selected={selectedPropertyOption ?? cssPropertyOptionsWithCustom[0]} onSelect={(selectedOption) => {
                                                                                if (selectedOption.value === '__custom__') {
                                                                                    updateActionItem(index, (item) => {
                                                                                        const nextProperties = renameEntryKey(item.properties ?? {}, key, '--custom-property');
                                                                                        return {
                                                                                            ...item,
                                                                                            properties: nextProperties
                                                                                        };
                                                                                    });
                                                                                    return;
                                                                                }

                                                                                updateActionItem(index, (item) => {
                                                                                    const nextProperties = renameEntryKey(item.properties ?? {}, key, selectedOption.value);
                                                                                    return {
                                                                                        ...item,
                                                                                        properties: nextProperties
                                                                                    };
                                                                                });
                                                                            }} />
                                                                        </div>
                                                                        {isCustomProperty && (
                                                                            <TextInput appearance="modern" type="text" placeholder={"Custom property"} value={key} onKeyUp={(customKey) => {
                                                                                updateActionItem(index, (item) => {
                                                                                    const nextProperties = renameEntryKey(item.properties ?? {}, key, customKey);
                                                                                    return {
                                                                                        ...item,
                                                                                        properties: nextProperties
                                                                                    };
                                                                                });
                                                                            }} />
                                                                        )}
                                                                        {renderActionPropertyValueEditor(key, value, (nextValue) => {
                                                                            updateActionItem(index, (item) => {
                                                                                const nextProperties = { ...(item.properties ?? {}) };
                                                                                nextProperties[key] = nextValue;
                                                                                return {
                                                                                    ...item,
                                                                                    properties: nextProperties
                                                                                };
                                                                            });
                                                                        })}
                                                                    </div>
                                                                )
                                                            }} />
                                                            <div className={typo.caption}>ATTRIBUTES</div>
                                                            <Each of={attributesEntries} render={([key, value]) => {
                                                                const isCustomAttribute = !attributeValueSet.has(key);
                                                                const selectedAttributeOption = isCustomAttribute
                                                                    ? attributeOptionsWithCustom[attributeOptionsWithCustom.length - 1]
                                                                    : attributeOptionsWithCustom.find((option) => option.value === key);

                                                                return (
                                                                    <div className={styles.property}>
                                                                        <div className={styles.propertyTopRow}>
                                                                            <DeleteIcon className={styles.deleteProperty} onClick={() => {
                                                                                updateActionItem(index, (item) => {
                                                                                    const nextAttributes = { ...(item.attributes ?? {}) };
                                                                                    delete nextAttributes[key];
                                                                                    return {
                                                                                        ...item,
                                                                                        attributes: nextAttributes
                                                                                    };
                                                                                });
                                                                            }} />
                                                                            <Select appearance="modern" options={attributeOptionsWithCustom} selected={selectedAttributeOption ?? attributeOptionsWithCustom[0]} onSelect={(selectedOption) => {
                                                                                if (selectedOption.value === '__custom__') {
                                                                                    updateActionItem(index, (item) => {
                                                                                        const nextAttributes = renameEntryKey(item.attributes ?? {}, key, 'data-custom');
                                                                                        return {
                                                                                            ...item,
                                                                                            attributes: nextAttributes
                                                                                        };
                                                                                    });
                                                                                    return;
                                                                                }

                                                                                updateActionItem(index, (item) => {
                                                                                    const nextAttributes = renameEntryKey(item.attributes ?? {}, key, selectedOption.value);
                                                                                    return {
                                                                                        ...item,
                                                                                        attributes: nextAttributes
                                                                                    };
                                                                                });
                                                                            }} />
                                                                        </div>
                                                                        {isCustomAttribute && (
                                                                            <TextInput appearance="modern" type="text" placeholder={"Custom attribute"} value={key} onKeyUp={(customKey) => {
                                                                                updateActionItem(index, (item) => {
                                                                                    const nextAttributes = renameEntryKey(item.attributes ?? {}, key, customKey);
                                                                                    return {
                                                                                        ...item,
                                                                                        attributes: nextAttributes
                                                                                    };
                                                                                });
                                                                            }} />
                                                                        )}
                                                                        <TextInput appearance="modern" type="text" placeholder={"Value"} value={value} onKeyUp={(nextValue) => {
                                                                            updateActionItem(index, (item) => {
                                                                                const nextAttributes = { ...(item.attributes ?? {}) };
                                                                                nextAttributes[key] = nextValue;
                                                                                return {
                                                                                    ...item,
                                                                                    attributes: nextAttributes
                                                                                };
                                                                            });
                                                                        }} />
                                                                    </div>
                                                                )
                                                            }} />
                                                            <div className={styles.actionAddButtonsRow}>
                                                                <Button appearance='text' additionalClass={styles.actionAddButton} onClick={() => {
                                                                    updateActionItem(index, (item) => {
                                                                        const nextProperties = { ...(item.properties ?? {}) };
                                                                        const nextKey = cssPropertyOptionsSorted.find((property) => !Object.prototype.hasOwnProperty.call(nextProperties, property.value))?.value ?? '--custom-property';
                                                                        nextProperties[nextKey] = '';
                                                                        return {
                                                                            ...item,
                                                                            properties: nextProperties
                                                                        };
                                                                    });
                                                                }}>ADD PROPERTY</Button>
                                                                <Button appearance='text' additionalClass={styles.actionAddButton} onClick={() => {
                                                                    updateActionItem(index, (item) => {
                                                                        const nextAttributes = { ...(item.attributes ?? {}) };
                                                                        const nextKey = attributeOptions.find((attribute) => !Object.prototype.hasOwnProperty.call(nextAttributes, attribute.value))?.value ?? 'data-custom';
                                                                        nextAttributes[nextKey] = '';
                                                                        return {
                                                                            ...item,
                                                                            attributes: nextAttributes
                                                                        };
                                                                    });
                                                                }}>ADD ATTRIBUTE</Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        }} />
                                        <Button appearance='text' fullWidth onClick={() => {
                                            let actions = data?.actions ? [...data.actions] : []
                                            actions.push({ type: 'onClick', target: '', properties: {}, attributes: {} })
                                            updateDataProperty('actions', actions)
                                            setExpandedActionIndex(actions.length - 1)
                                        }}>ADD ACTION</Button>
                                    </div>
                                </Collapsable>
                                {/* <Collapsable title='CUSTOM VARIABLES' appearance='modern' active={Object.keys(viewStyle).filter(k => k.startsWith('--')).length > 0}>
                                    <div className={styles.collapsibleContent}>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <th align='left'>
                                                        <div className={typo.caption}>VARIABLE</div>
                                                    </th>
                                                    <th align='left'>
                                                        <div className={typo.caption}>VALUE</div>
                                                    </th>
                                                    <th></th>
                                                </tr>

                                                <Each of={Object.keys(viewStyle).filter(k => k.startsWith('--'))} render={(key, index) => {
                                                    return (
                                                        <tr>
                                                            <td align='left' style={{ fontSize: '.75rem' }}>{key}</td>
                                                            <td align='left' style={{ fontSize: '.75rem' }}>{viewStyle[key]}</td>
                                                            <td>
                                                                <DeleteIcon style={{ cursor: 'pointer', color: 'var(--sf-red)' }} onClick={() => {
                                                                    let newStyle = { ...style }
                                                                    delete newStyle[key]
                                                                    setStyle(newStyle)
                                                                }} />
                                                            </td>
                                                        </tr>
                                                    )
                                                }} />
                                            </tbody>
                                        </table>
                                        <KeyValueSelector key={''} value={''} onChange={(key, value) => {
                                            setStyle({ ...style, [key]: value })
                                        }} />
                                    </div>
                                </Collapsable> */}
                            </>
                        }
                        <Collapsable title='SETTINGS' appearance='modern' active={grid}>
                            <div className={styles.collapsibleContent}>
                                <div className={styles.toggle}>
                                    <Checkbox size="20px" label="Show grid" labelPosition='end' radius="6px" value={grid} style={{ maxHeight: '20px' }}
                                        onChange={(checked) => {
                                            onGridUpdate(checked)
                                        }} />
                                </div>
                            </div>
                        </Collapsable>
                    </div>
                }

                <div className={styles.bottomBar}>
                    {activeVersion === 'draft' && (
                        <Button
                            disabled={saveDisabled || isSaving}
                            onClick={onSaveDraft}
                            accentColor="var(--sf-green)"
                            status={saveDraftButtonStatus}
                            style={{ padding: '1rem' }}
                            inverse
                        >
                            SALVA IN BOZZA
                        </Button>
                    )}
                    {activeVersion === 'published' && !hideExportToDraft && (
                        <Button
                            disabled={saveDisabled || isSaving}
                            onClick={onExportToDraft}
                            accentColor="var(--sf-green)"
                            style={{ padding: '1rem' }}
                            inverse
                        >
                            ESPORTA IN BOZZA
                        </Button>
                    )}
                    <Button
                        disabled={saveDisabled || isSaving}
                        onClick={onPublish}
                        accentColor={"var(--sf-red)"}
                        status={publishButtonStatus}
                        style={{ padding: '1rem' }}
                    >
                        PUBBLICA
                    </Button>
                    <LastSavedStatus value={lastSavedAt} className={styles.lastSaved} />
                </div>
            </div>
            {actionTargetPickerIndex != null && (
                <div className={styles.actionTargetPickerFloating}>
                    <div className={styles.actionTargetPickerInfo}>
                        Seleziona il blocco nel builder (mouse o shortcut) e conferma.
                        <span>Target corrente: {actionTargetCandidateId ? `#${actionTargetCandidateId}` : 'vuoto'}</span>
                    </div>
                    <div className={styles.actionTargetPickerButtons}>
                        <Button inverse onClick={() => {
                            setActionTargetPickerIndex(null);
                            setActionTargetCandidateId(null);
                            setActionTargetSourceBlockId(null);
                        }}>
                            ANNULLA
                        </Button>
                        <Button onClick={confirmActionTargetSelection}>
                            CONFERMA TARGET
                        </Button>
                    </div>
                </div>
            )}
            <IconsDialog
                open={iconsDialogOpen}
                selected={data?.icon?.name}
                onClose={() => {
                    setIconsDialogOpen(false)
                }}
                onSelect={async (icon) => {
                    const svgData = icon.data.replace(/fill="#[^"]*"/g, `fill="currentColor"`).replace(/stroke="#[^"]*"/g, 'stroke="currentColor"')
                    updateDataProperty('icon', { data: svgData, name: icon.svgFileName, style: { objectFit: 'contain' } })
                    setIconsDialogOpen(false)
                }} />
            <Dialog
                open={mdxColorDialogOpen}
                title="Colore testo selezionato"
                onClose={handleCloseMdxColorDialog}
                style={{ maxWidth: '420px' }}
                contentMaxHeight="80vh"
                overflow="visible"
            >
                <div className={styles.mdxColorDialogContent}>
                    <ColorPicker
                        className={styles.colorPicker}
                        disableDarkMode
                        width={350}
                        height={100}
                        hidePresets
                        hideAdvancedSliders
                        hideColorGuide
                        hideInputType
                        hideColorTypeBtns
                        value={mdxInlineColor}
                        onChange={(color) => {
                            setMdxInlineColor(color)
                        }}
                    />
                    <div className={styles.selectorsRow}>
                        <UnitSelector
                            value={mdxInlineFontSize}
                            label="FONT SIZE"
                            onChange={(value) => {
                                setMdxInlineFontSize(value ?? '')
                            }}
                        />
                        <Select appearance="modern"
                            options={mdxInlineFontWeightOptions}
                            selected={mdxInlineFontWeightOptions.find((option) => option.value === mdxInlineFontWeight) ?? mdxInlineFontWeightOptions[0]}
                            onSelect={(option) => {
                                setMdxInlineFontWeight(option?.value ?? '')
                            }}
                        />
                    </div>
                    <div className={styles.themeColors}>
                        <Each of={themeColors} render={(color) => {
                            return (
                                <TooltipWrapper text={`${color.hex}`}>
                                    <div
                                        onClick={() => {
                                            setMdxInlineColor(color.value)
                                        }}
                                        className={styles.color}
                                        style={{ backgroundColor: `${color.value}` }}
                                    ></div>
                                </TooltipWrapper>
                            )
                        }} />
                    </div>
                    {renderUsedPageColors((colorValue) => {
                        setMdxInlineColor(colorValue)
                    })}
                    <div className={styles.mdxColorDialogActions}>
                        <Button inverse onClick={handleResetMdxInlineStyle}>RESET</Button>
                        <Button onClick={handleApplyMdxInlineColor}>APPLICA</Button>
                    </div>
                </div>
            </Dialog>
        </>
    )

}

export default PageBuilderToolbar
